import React from "react";
import TableHead from "./TableHead";
import TableBody from "./TableBody";
import TableFooter from "./TableFooter";
import {toast} from "react-toastify";
import "./editableTable.scss";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import {getObjectFromArrayOfObjects} from "../../../_helpers/helperFunctions";
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";
import {
    getCurrentUser,
    getGreekCurrencyFormat, getGreekNumberFormat, getIsNetValueOptions,
    getSavedHiddenColumns, getTaxTypeOptions,
    isEmpty, hookCompanyLogo
} from "../../../_helpers/commonFunctions";
import * as XLSX from "xlsx";
import {liberationSerif} from "../../../fonts/liberationSerif";
import axios from "axios";
import {Col, Modal, Row} from "react-bootstrap";
import moment from "moment";
import {dejavuSans} from "../../../fonts/DejaVuSans-normal";
import {dejavuSansBold} from "../../../fonts/DejaVuSans-Bold-bold";
import DeleteModal from "../POPUP-COMPONENTS/Delete-Modal/deleteModal";
import getMyData from "../../../_helpers/sharedmydata";
import {dclStatusOptions, providedServiceCategoryOptions} from "../../layouts/data-panel/dcl/dclStatusOptions";
import {clientServiceTypes} from "../../../_data/mydata/clientServiceTypes";
import {vehicleCategoryOptions} from "../../../_data/mydata/vehicleCategoryOptions";
import Pagination from "../Pagination";

class EditableTable extends React.Component {
    constructor(props) {
        super(props);
        this.editableTableRef = React.createRef();
        this.iframeRef = React.createRef();

        this.state = {
            tableData: this.props.data,
            iframeData: "",
            tabCloseWarning: false,
            cancelTabCloseWarning: false,
            showResponseSentToMyData: false,
            showResponseCancelToMyData: false,
            responseSentToMyData: false,
            responseCancelToMyData: false,
            loadingSendSelected: false,
            reqName: this.props.reqName,
            pRequestData: this.props.pRequestData,
            tableName: this.props.tableName,
            filters: this.props.filters,
            filteredData: [],
            renderedData: [],
            loader: false,
            checkedRows: [],
            tableColumns: this.props.columns,
            reportColumns: this.props.reportColumns,
            emronPaymentsMonth: this.props.emronPaymentsMonth,
            count: this.props.data ? this.props.totalItems : 0,
            activePage: 1,
            rowsPerPage: this.props.perPage,
            pageRange: 5,
            requestData: this.props.requestData,
            formData: this.props.formData,
            // For delete modal
            showDelete: false,
            toBeDeleted: "",
            allChecked: this.props.allChecked ?? false,
            searchExportLoader: false,
            allowSorting: this.props.allowSorting,
            fixedLayout: this.props.fixedLayout
        }
        this.companyDetails = this.props.companyDetails;
    }

    componentDidMount = () => {
        // Action Buttons for the Table,
        // Default: Delete button is true
        let defaultButtons = {edit: false, print: false, export: false, delete: false};
        if (
            this.state.tableName !== "Product Balance Report" &&
            this.state.tableName !== "Sales Balance Sheet" &&
            this.state.tableName !== "Client Payments Report" &&
            this.state.tableName !== "Buys Balance Sheet" &&
            this.state.tableName !== "Supplier Payments Report" &&
            this.state.tableName !== "Product Movements Report" &&
            this.state.tableName !== "Client Balance Report" &&
            this.state.tableName !== "Supplier Balance Report"
        ) {
            defaultButtons.delete = true;
        }

        // This will replace the action buttons with props values.
        let actionButtons = defaultButtons;
        if (this.props.actionButtons) {
            actionButtons = this.props.actionButtons;
        }

        if (this.props.tableName === "Product Variants") {
            this.setState((state) => {
                return {checkedRows: this.props.selectedRows}
            });
        }

        // Selection Check box
        const selectionCheckboxColumn = {
            enabled: this.props.allowSelectionCheckbox
                ? this.props.allowSelectionCheckbox
                : false,
            field: "select_checkbox",
            name: "Select All",
            width: "40px",
            inputType: {
                type: "selection",
                select: (e, type, dataKey, row) => {
                    switch (type) {
                        case "selectRow":
                            if(this.props?.selectedRows && this.props?.setSelectedRows && this.props?.selectedRowKey) {
                                const { selectedRows, setSelectedRows, selectedRowKey } = this.props;
                                const key = String(row?.[selectedRowKey] ?? "");
                                if (!key) {
                                    console.warn("Row key is empty. selectedRowKey:", selectedRowKey, "row:", row);
                                    return;
                                }
                                const exists = selectedRows.some(k => String(k) === key);
                                const nextSelectedRows = exists ? selectedRows.filter(k => String(k) !== key) : [...selectedRows, key];
                                setSelectedRows(nextSelectedRows);
                            } else {
                                this.setState((state) => {
                                    let selectedIndexes = state.checkedRows.slice();
                                    const foundIndex = selectedIndexes?.indexOf(parseInt(dataKey));
                                    if (foundIndex > -1) {
                                        selectedIndexes.splice(foundIndex, 1); // Remove from array
                                    } else {
                                        selectedIndexes.push(parseInt(dataKey)); // Add to array
                                    }
                                    return {
                                        checkedRows: selectedIndexes,
                                    };
                                });
                            }
                            break;
                        case "selectAll":
                            if(this.props?.selectedRows && this.props?.setSelectedRows && this.props?.selectedRowKey) {
                                const { selectedRows, setSelectedRows } = this.props;
                                const isAllChecked = Array.isArray(selectedRows) && ((selectedRows.length === 1 && selectedRows[0] === -1) ||  (selectedRows.length === this.props?.totalItems && !selectedRows.some((el) => el === -1)));
                                setSelectedRows(isAllChecked ? [] : [-1]);
                            } else {
                                this.setState(() => {
                                    let selectedIndexes;
                                    if (selectedIndexes?.length > 0) {
                                        selectedIndexes = [];
                                    } else {
                                        selectedIndexes = [...Array(this.state.count).keys()];
                                    }
                                    console.log("select all rows.", selectedIndexes);
                                    return {
                                        checkedRows: selectedIndexes,
                                    };
                                });
                            }
                            break;
                        default:
                            console.log("nothing to do..");
                    }
                },
            },
        };
        // It will add the actions column in the Table
        const actionsColumns = {
            field: "actions",
            name: "",
            width: "80px",
            actionButtons: actionButtons,
            inputType: {
                type: "actions",
                callbackFn: (dataKey, type, rowIndex, rowData) => {
                    if (type === "delete") {
                        this.handleDelete(dataKey, rowIndex, rowData);
                    } else if (type === "edit") {
                        this.handleEdit(dataKey);
                    } else if (type === "select") {
                        this.handleSelect(rowIndex, rowData);
                    } else if (type === "showContactPoints") {
                        this.handleShowContactPoints(rowIndex);
                    } else if (type === "showAiAnalysis") {
                        this.handleShowAiAnalysis(rowIndex, rowData);
                    }
                },
            },
        }
        if (this.props.allowSelectionCheckbox && this.props.allowActions) {
            this.setState({tableColumns: [selectionCheckboxColumn, ...this.state.tableColumns, actionsColumns]});
        } else if (this.props.allowSelectionCheckbox) {
            this.setState({tableColumns: [selectionCheckboxColumn, ...this.state.tableColumns]});
        } else if (this.props.allowActions) {
            this.setState({tableColumns: [...this.state.tableColumns, actionsColumns]});
        }
        this.setState((state) => {
            if (state.tableData && state.tableData.length > 0) {
                return {
                    filteredData: state.tableData ? state.tableData.slice(0, state.rowsPerPage) : []
                }
            }
        })
    }

    handlePageChange = (pageNumber) => {
        this.setState({activePage: pageNumber, requestData: {...this.state.requestData, page: pageNumber}}, () => {})
    }

    // It will allow to edit the table data.
    handleEdit = (dataKey) => {
        // Quick Edit Case
        this.props.onUpdate &&
        this.props.onUpdate.update({quickEdit: "true"}, dataKey);
    }

    handleSelect = (rowIndex, rowData) => {
        this.props.onSelect(rowIndex, rowData);
    }

    handleShowContactPoints = (rowIndex) => {
        this.setState(prevState => {
            const updatedData = [...prevState.tableData];
            updatedData[rowIndex] = {...updatedData[rowIndex], showContactPoints: !updatedData[rowIndex].showContactPoints};
            return { tableData: updatedData }
        });
    }

    handleShowAiAnalysis = (rowIndex, rowData) => {
        if (this.props.onUpdate && this.props.onUpdate.showAiAnalysis) {
            this.props.onUpdate.showAiAnalysis(rowData.id, rowIndex, rowData);
        }
    }

    // It will delete the selected row
    handleDelete = (id, rowIndex, rowData) => {
        const customDeletions = [
            "Search Products",
            "Search Product Movements",
            "Search Product Price List",
            "Product Category",
            "Sales Search",
            "Quotations Search",
            "Client Payments Search",
            "Sales Ways Of Sending Goods",
            "Sales Car Numbers",
            "Buys Search",
            "Supplier Payments Search",
            "Buys Ways Of Sending Goods",
            "Buys Car Numbers",
            "Client Search",
            "Client Movements Search",
            "Supplier Search",
            "Supplier Movements Search",
            "Cash Registers Search",
            "POS Search",
            "Cheques Search",
            "Loans Search",
            "Cards Search",
            "Bank Account Search",
            "Basic Types Search",
            "Advanced Types Search",
            "Employees Search",
            "Accounting Account Search",
            "Accounting Record Search",
            "Work Permits Search",
            "Fixed Asset Movements Search",
            "Fixed Asset Records Search",
            "Fixed Assets Search",
            "Fixed Assets Categories",
        ]
        if (customDeletions.includes(this.state.tableName) && String(id).length === 24) {
            this.showDeleteModal(true);
            this.setState({toBeDeleted: id});
        } else {
            this.props.onUpdate && this.props.onUpdate.delete(id, rowIndex, rowData);
        }
    }

    showDeleteModal = (bool) => {
        if (bool === false) this.setState({toBeDeleted: ""});
        this.setState({showDelete: bool});
    }

    // It will insert a new Row to the Table Data.
    handleInsertNewRowToData = (e, data) => {
        this.props.onUpdate && this.props.onUpdate.insert(e, data);
        const {count} = this.state;
        if (data.value !== "" && data.field !== "") {
            this.setState({count: count + 1});
        }
    };

    // Update Row Data
    handleUpdateRowToData = (e, field, id, rowIndex) => {
        if ((this.props.tableName === "Sales Modal Products List" || this.props.tableName === "Buys Modal Products List") && field === "name") {
            this.props.onUpdate.update({name: e.row}, id, rowIndex);
            return;
        }

        let value;
        if (e?.target !== undefined) {
            value = e.target.value;
        } else if (e?.value !== undefined) {
            value = e.value;
        } else {
            value = e;
        }

        if (field !== "") {
            const newData = {
                [field]: value,
            };
            if (
                this.props.tableName === "Client Movements Clients" ||
                this.props.tableName === "Edit Client Movements Clients" ||
                this.props.tableName === "Supplier Movements Suppliers" ||
                this.props.tableName === "New Price List General"
            ) {
                this.props.onUpdate && this.props.onUpdate.update(newData, id, e);
            } else {
                this.props.onUpdate && this.props.onUpdate.update(newData, id, rowIndex, e);
            }
        }
    };
    handleIframeLoad = () => {
        // wait for the iframe content to load
        if (this.state.iframeData && this.iframeRef.current) {
            // access the iframe's window object
            const iframeWindow = this.iframeRef.current.contentWindow;
            // print the iframe content
            iframeWindow.print();
        }
    }

    handleExportToPdfReport = (ext = ".pdf", name = null, printer = false) => {
        this.setState({
            loader: true,
        });
        if (this.props.tableName === "Product Balance Report") {
            const tableColumns = this.state.tableColumns;
            const tableName = this.props.tableName;
            let requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                date_to: this.props.filters?.date_to ? this.props.filters?.date_to : "",
                product_inactive: this.props.filters.product_inactive,
                product_zero: this.props.filters.product_zero,
                installation: this.props.filters?.installation ? this.props.filters.installation.map(el => el.value) : [],
                productName: this.props.filters?.productName,
            };
            axios.post(process.env.REACT_APP_API_URL2 + `/report/export-report`, requestData, {
                headers: {"Content-Type": "application/json"}
            })
                .then((res) => {
                    let dR = [];
                    if (res.data && res.data.status === "200") {
                        if (res.data.data.length > 0) {
                            res.data.data.forEach((element, i) => {
                                let obj = element;
                                obj.no = i + 1;
                                obj.productName = element._id.productName;
                                dR.push(obj);
                            });
                        }
                    } else {
                        if (res.data && res.data.message) {
                            toast.error(res.data && res.data.message);
                        } else {
                            toast.error(res.data && res.data.error);
                        }
                    }
                    const doc = new jsPDF('landscape');
                    this.setState({loader: false});
                    let y = 20;

                    doc.addFileToVFS("arialuni.ttf", liberationSerif);
                    doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                    doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                    doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                    doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                    doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
                    doc.setFont("DejaVu Sans Bold");
                    doc.setFontSize(17);
                    const header = doc.splitTextToSize("Υπόλοιπο Ειδών", 200);
                    const headerString = header.join("\n");
                    doc.text(headerString, doc.internal.pageSize.getWidth() / 2.5, 9, {alignment: "center"});

                    hookCompanyLogo(doc, this.props.companyDetails);

                    const imgData = 'assets/images/prrimer-logo.png';
                    const imgWidth = 28;
                    const imgHeight = 10;
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const pageHeight = doc.internal.pageSize.getHeight();

                    doc.addImage(imgData, 'PNG', pageWidth - imgWidth - 10, pageHeight - imgHeight - 5, imgWidth, imgHeight);
                    doc.setFont("DejaVu Sans Normal");
                    doc.setFontSize(11);
                    doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY HH:mm:ss")}`, 15, 18, {alignment: "center"});

                    const columns = ["Απόθεμα", "Κωδικός Προϊόντος", "Εναλλακτικός Κωδικός", "Όνομα Προϊόντος", "Υπόλοιπο", "Κόστος Αποθήκης"];
                    let rows;
                    let totalBalance = 0;
                    let totalWarehouseCost = 0;
                    if (dR.length > 0) {
                        rows = dR.map((movement) => {
                            totalBalance = totalBalance + Number(movement.balance);
                            totalWarehouseCost = totalWarehouseCost + Number(movement.warehouseCost);
                            return [
                                movement.inventory.toLocaleString('de-DE', {minimumFractionDigits: 2, useGrouping: true, groupingSeparator: '.'}),
                                movement.code,
                                movement.alternateCode,
                                movement.productName,
                                movement.balance.toLocaleString('de-DE', {minimumFractionDigits: 2, useGrouping: true, groupingSeparator: '.'}),
                                getGreekCurrencyFormat(movement.warehouseCost),
                            ]
                        });
                        rows.push([
                            "",
                            "Συνολικό Υπόλοιπο Ειδών",
                            "",
                            "",
                            totalBalance.toLocaleString('de-DE', {minimumFractionDigits: 2, useGrouping: true, groupingSeparator: '.'}),
                            getGreekCurrencyFormat(totalWarehouseCost)
                        ])
                    } else {
                        rows = [{no: "no record found"}];
                    }

                    autoTable(doc, {
                        startY: y,
                        head: [columns],
                        body: rows,
                        theme: "striped",
                        rowPageBreak: "avoid",
                        styles: {
                            font: "DejaVu Sans Normal",
                            fontStyle: "normal",
                            fontSize: 10,
                            halign: "center",
                        },
                        didParseCell: (data) => {
                            if (data.row.raw === columns || data.row.index === rows.length - 1) {
                                data.cell.styles.fillColor = [241, 253, 255];
                                data.cell.styles.textColor = [0, 0, 0];
                                data.cell.styles.font = "DejaVu Sans Bold";
                            } else {
                                data.cell.styles.textColor = [0, 0, 0];
                            }
                        }
                    });

                    const pageCount = doc.getNumberOfPages();
                    for (let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        doc.setFontSize(10);
                        doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                    }

                    if (printer) {
                        this.setState({iframeData: `${doc.output('bloburl')}`});
                    } else {
                        doc.save("Product Balance Report.pdf");
                    }
                })
                .catch((error) => {
                    toast.error("Something went wrong. Please try again later!");
                    console.log(error);
                });
        } else if (this.props.tableName === "Sales Monthly Turnover") {
            const tableColumns = this.state.tableColumns;
            const tableName = this.props.tableName;
            let requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                date_from: this.props.filters?.date_from,
                date_to: this.props.filters?.date_to,
                clientName: this.props.filters?.clientName,
            }
            axios.post(process.env.REACT_APP_API_URL2 + `/report/export-report`, requestData, {
                headers: {"Content-Type": "application/json"}
            }).then((res) => {
                let dR = res.data.data;
                if (res.data && res.data.status === "200") {
                    const doc = new jsPDF('landscape');
                    this.setState({loader: false});
                    let y = 20;

                    doc.addFileToVFS("arialuni.ttf", liberationSerif);
                    doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                    doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                    doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                    doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                    doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
                    doc.setFont("DejaVu Sans Bold");
                    doc.setFontSize(17);
                    const header = doc.splitTextToSize("Τζίρος Πωλήσεων Ανά Περίοδο", 200);
                    const headerString = header.join("\n");
                    doc.text(headerString, doc.internal.pageSize.getWidth() / 2.5, 9, {alignment: "center"});

                    hookCompanyLogo(doc, this.props.companyDetails);

                    const imgData = 'assets/images/prrimer-logo.png';
                    const imgWidth = 28;
                    const imgHeight = 10;
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const pageHeight = doc.internal.pageSize.getHeight();
                    doc.addImage(imgData, 'PNG', pageWidth - imgWidth - 10, pageHeight - imgHeight - 5, imgWidth, imgHeight);
                    doc.setFont("DejaVu Sans Normal");
                    doc.setFontSize(11);
                    doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY HH:mm:ss")}`, 15, 18, {alignment: "center"});

                    let columns = [];
                    tableColumns.forEach(column => {
                        if (column.field !== "actions" && column.field !== "no" && !column.hiddenColumn) {
                            columns.push(column);
                        }
                    })
                    let columnNames = columns.map(column => {
                        return column?.shortcut;
                    })

                    let rows;
                    let totalPaymentAmount = 0;
                    if (dR.length > 0) {
                        rows = dR.map((data) => {
                            totalPaymentAmount += data.cTotal;
                            data = Object.values(data).map(el => !isNaN(el) ? getGreekCurrencyFormat(el) : el);
                            return data;
                        });
                        rows.push(["Γενικό Σύνολο", "", "", "", "", "", "", "", "", "", "", "", "", getGreekCurrencyFormat(totalPaymentAmount)])
                    } else {
                        rows = [{no: "no record found"}];
                    }

                    autoTable(doc, {
                        startY: y,
                        head: [columnNames],
                        body: rows,
                        theme: "striped",
                        rowPageBreak: "avoid",
                        styles: {
                            font: "DejaVu Sans Normal",
                            fontStyle: "normal",
                            fontSize: 7.5,
                            cellPadding: 1.5,
                            valign: "middle",
                            halign: "left",
                            overflow: "linebreak",
                        },
                        headStyles: {
                            font: "DejaVu Sans Bold",
                            fontSize: 8,
                            halign: "center",
                            fillColor: [241, 253, 255],
                            textColor: [0, 0, 0]
                        },
                        columnStyles: {
                            0: { halign: "center", cellWidth: 40 },
                        },
                        didParseCell: (data) => {
                            if (data.row.index === rows.length - 1) {
                                data.cell.styles.fillColor = [241, 253, 255];
                                data.cell.styles.textColor = [0, 0, 0];
                                data.cell.styles.font = "DejaVu Sans Bold";
                            }

                            if (data.cell.text && data.cell.text.some(t => t.includes('€'))) {
                                data.cell.styles.halign = 'right';
                            }
                        }
                    });

                    const pageCount = doc.getNumberOfPages();
                    for (let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        doc.setFontSize(10);
                        doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                    }

                    if (printer) {
                        this.setState({iframeData: `${doc.output('bloburl')}`});
                    } else {
                        doc.save("Αναφορά Τζίρου Πωλήσεων.pdf");
                    }
                } else if (res.data && res.data.status === "422") {
                    toast.error("Something went wrong. Please try again later!");
                }
            }).catch((error) => {
                console.log(error);
                toast.error("Something went wrong. Please try again later!");
            })
        } else if (this.props.tableName === "Buys Monthly Turnover") {
            const tableColumns = this.state.tableColumns;
            const tableName = this.props.tableName;
            let requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                date_from: this.props.filters?.date_from,
                date_to: this.props.filters?.date_to,
                supplierName: this.props.filters?.supplierName,
            }
            axios.post(process.env.REACT_APP_API_URL2 + `/report/export-report`, requestData, {
                headers: {"Content-Type": "application/json"}
            }).then((res) => {
                let dR = res.data.data;
                if (res.data && res.data.status === "200") {
                    const doc = new jsPDF('landscape');
                    this.setState({loader: false});
                    let y = 20;

                    doc.addFileToVFS("arialuni.ttf", liberationSerif);
                    doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                    doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                    doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                    doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                    doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
                    doc.setFont("DejaVu Sans Bold");
                    doc.setFontSize(17);
                    const header = doc.splitTextToSize("Τζίρος Αγορών Ανά Περίοδο", 200);
                    const headerString = header.join("\n");
                    doc.text(headerString, doc.internal.pageSize.getWidth() / 2.5, 9, {alignment: "center"});

                    hookCompanyLogo(doc, this.props.companyDetails);

                    const imgData = 'assets/images/prrimer-logo.png';
                    const imgWidth = 28;
                    const imgHeight = 10;
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const pageHeight = doc.internal.pageSize.getHeight();
                    doc.addImage(imgData, 'PNG', pageWidth - imgWidth - 10, pageHeight - imgHeight - 5, imgWidth, imgHeight);
                    doc.setFont("DejaVu Sans Normal");
                    doc.setFontSize(11);
                    doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY HH:mm:ss")}`, 15, 18, {alignment: "center"});

                    let columns = [];
                    tableColumns.forEach(column => {
                        if (column.field !== "actions" && column.field !== "no" && !column.hiddenColumn) {
                            columns.push(column);
                        }
                    })
                    let columnNames = columns.map(column => {
                        return column?.shortcut;
                    })

                    let rows;
                    let totalPaymentAmount = 0;
                    if (dR.length > 0) {
                        rows = dR.map((data) => {
                            totalPaymentAmount += data.sTotal;
                            data = Object.values(data).map(el => !isNaN(el) ? getGreekCurrencyFormat(el) : el);
                            return data;
                        });
                        rows.push(["Γενικό Σύνολο", "", "", "", "", "", "", "", "", "", "", "", "", getGreekCurrencyFormat(totalPaymentAmount)])
                    } else {
                        rows = [{no: "no record found"}];
                    }

                    autoTable(doc, {
                        startY: y,
                        head: [columnNames],
                        body: rows,
                        theme: "striped",
                        rowPageBreak: "avoid",
                        styles: {
                            font: "DejaVu Sans Normal",
                            fontStyle: "normal",
                            fontSize: 7.5,
                            cellPadding: 1.5,
                            valign: "middle",
                            halign: "left",
                            overflow: "linebreak",
                        },
                        headStyles: {
                            font: "DejaVu Sans Bold",
                            fontSize: 8,
                            halign: "center",
                            fillColor: [241, 253, 255],
                            textColor: [0, 0, 0]
                        },
                        columnStyles: {
                            0: { halign: "center", cellWidth: 40 },
                        },
                        didParseCell: (data) => {
                            if (data.row.index === rows.length - 1) {
                                data.cell.styles.fillColor = [241, 253, 255];
                                data.cell.styles.textColor = [0, 0, 0];
                                data.cell.styles.font = "DejaVu Sans Bold";
                            }

                            if (data.cell.text && data.cell.text.some(t => t.includes('€'))) {
                                data.cell.styles.halign = 'right';
                            }
                        }
                    });

                    const pageCount = doc.getNumberOfPages();
                    for (let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        doc.setFontSize(10);
                        doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                    }

                    if (printer) {
                        this.setState({iframeData: `${doc.output('bloburl')}`});
                    } else {
                        doc.save("Αναφορά Τζίρου Αγορών.pdf");
                    }
                } else if (res.data && res.data.status === "422") {
                    toast.error("Something went wrong. Please try again later!");
                }
            }).catch((error) => {
                console.log(error);
                toast.error("Something went wrong. Please try again later!");
            })
        } else if (this.props.tableName === "Sales Balance Sheet") {
            const tableColumns = this.state.tableColumns;
            const tableName = this.props.tableName;
            let requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                date_from: this.props.filters?.date_from,
                date_to: this.props.filters?.date_to,
                clientName: this.props.filters?.clientName,
                productName: this.props.filters?.productName,
                totalSum_from: this.props.filters?.totalSum_from,
                totalSum_to: this.props.filters?.totalSum_to,
                preNumber_from: this.props.filters?.preNumber_from,
                preNumber_to: this.props.filters?.preNumber_to,
                numberFrom: this.props.filters?.numberFrom,
                numberTo: this.props.filters?.numberTo,
                myDataStatus: this.props.filters?.myDataStatus.map(el => el.value),
                paymentStatus: this.props.filters?.paymentStatus.map(el => el.value),
                notes: this.props.filters?.notes,
                invoiceType: this.props.filters?.invoiceType.map(el => el.value),
                paymentType: this.props.filters?.paymentType.map(el => el.value),
                automaticSales: this.props.filters?.automaticSales,
                carNumber: this.props.filters?.carNumber.map(el => el.value),
                providerChannel: this.props.filters?.providerChannel.map(el => el.value),
                installation: this.props.filters?.installation,
                country: this.props.filters?.country,
            }
            axios.post(process.env.REACT_APP_API_URL2 + `/report/export-report`, requestData, {
                headers: {"Content-Type": "application/json"}
            })
                .then((res) => {
                    let dR = [];
                    if (res.data && res.data.status === "200") {
                        if (res.data.data.length > 0) {
                            res.data.data.forEach((element) => {
                                let obj = element;
                                obj.number = obj.number.replace("noprefix", "");
                                dR.push(obj);
                            });
                        }
                        const doc = new jsPDF('landscape');
                        this.setState({loader: false});
                        let y = 20;

                        doc.addFileToVFS("arialuni.ttf", liberationSerif);
                        doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                        doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                        doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                        doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                        doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
                        doc.setFont("DejaVu Sans Bold");
                        doc.setFontSize(17);
                        const header = doc.splitTextToSize("Ανάλυση Πωλήσεων", 200);
                        const headerString = header.join("\n");
                        doc.text(headerString, doc.internal.pageSize.getWidth() / 2.5, 9, {alignment: "center"});

                        hookCompanyLogo(doc, this.props.companyDetails);

                        const imgData = 'assets/images/prrimer-logo.png';
                        const imgWidth = 28;
                        const imgHeight = 10;
                        const pageWidth = doc.internal.pageSize.getWidth();
                        const pageHeight = doc.internal.pageSize.getHeight();
                        doc.addImage(imgData, 'PNG', pageWidth - imgWidth - 10, pageHeight - imgHeight - 5, imgWidth, imgHeight);

                        doc.setFont("DejaVu Sans Normal");
                        doc.setFontSize(11);
                        doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY HH:mm:ss")}`, 15, 18, {alignment: "center"});

                        const columns = tableColumns.map((column) => {
                            if (column.field !== "actions" && column.field !== "no" && !column.hiddenColumn) {
                                return column;
                            }
                            return null;
                        }).filter(Boolean);
                        let columnNames = columns.map(column => {
                            return column?.name;
                        })
                        columnNames = columnNames.filter((element) => element !== undefined);

                        let rows;
                        let totalNetValue = 0;
                        let totalVatValue = 0;
                        let totalValue = 0;
                        let totalPaymentAmount = 0;
                        let totalVat24 = 0;
                        let totalVat17 = 0;
                        let totalVat13 = 0;
                        let totalVat9 = 0;
                        let totalVat6 = 0;
                        let totalVat4 = 0;
                        if (dR.length > 0) {
                            rows = dR.map((movement) => {
                                totalNetValue = totalNetValue + movement.totalNetValue;
                                totalVatValue = totalVatValue + movement.totalVatValue;
                                totalValue = totalValue + movement.totalAmount;
                                totalPaymentAmount = totalPaymentAmount + movement.paymentAmount;
                                if (movement.vat24) totalVat24 += movement.vat24;
                                else if (movement.vat13) totalVat13 += movement.vat13;
                                else if (movement.vat6) totalVat6 += movement.vat6;
                                else if (movement.vat17) totalVat17 += movement.vat17;
                                else if (movement.vat9) totalVat9 += movement.vat9;
                                else if (movement.vat4) totalVat4 += movement.vat4;

                                let row = [
                                    moment(movement.date).format("DD/MM/YYYY"),
                                    columns.find((element) => element?.field === "clientCode") ? movement.clientCode : undefined,
                                    columns.find((element) => element?.field === "clientName") ? movement.clientName : undefined,
                                    columns.find((element) => element?.field === "vat") ? movement.vat : undefined,
                                    columns.find((element) => element?.field === "phone") ? movement.phone : undefined,
                                    columns.find((element) => element?.field === "documentTypeName") ? movement.documentTypeName : undefined,
                                    columns.find((element) => element?.field === "number") ? movement.number : undefined,
                                    columns.find((element) => element?.field === "totalNetValue") ? getGreekCurrencyFormat(movement.totalNetValue) : undefined,
                                    columns.find((element) => element?.field === "vatAmount") ? getGreekCurrencyFormat(movement.totalVatValue) : undefined,
                                    columns.find((element) => element?.field === "vat24") ? getGreekCurrencyFormat(movement.vat24) : undefined,
                                    columns.find((element) => element?.field === "vat13") ? getGreekCurrencyFormat(movement.vat13) : undefined,
                                    columns.find((element) => element?.field === "vat6") ? getGreekCurrencyFormat(movement.vat6) : undefined,
                                    columns.find((element) => element?.field === "vat17") ? getGreekCurrencyFormat(movement.vat17) : undefined,
                                    columns.find((element) => element?.field === "vat9") ? getGreekCurrencyFormat(movement.vat9) : undefined,
                                    columns.find((element) => element?.field === "vat4") ? getGreekCurrencyFormat(movement.vat4) : undefined,
                                    columns.find((element) => element?.field === "totalAmount") ? getGreekCurrencyFormat(movement.totalAmount) : undefined,
                                    columns.find((element) => element?.field === "paymentTypeName") ? movement.paymentTypeName : undefined,
                                    columns.find((element) => element?.field === "vehNumber") ? movement.vehNumber : undefined,
                                    columns.find((element) => element?.field === "providerChannel") ? movement.providerChannel : undefined,
                                    columns.find((element) => element?.field === "productNamesBalanceSheet") ? movement.productNamesBalanceSheet : undefined,
                                    columns.find((element) => element?.field === "paymentAmount") ? getGreekCurrencyFormat(movement.paymentAmount) : undefined,
                                    columns.find((element) => element?.field === "mark") ? movement.mark : undefined,
                                    columns.find((element) => element?.field === "country") ? movement.country : undefined,
                                ]
                                return row.filter((item) => item !== undefined);
                            });
                            let row = [
                                "",
                                columns.find((element) => element?.field === "clientCode") ? "" : undefined,
                                columns.find((element) => element?.field === "clientName") ? "Συνολικά Ποσά" : undefined,
                                columns.find((element) => element?.field === "vat") ? "" : undefined,
                                columns.find((element) => element?.field === "phone") ? "" : undefined,
                                columns.find((element) => element?.field === "documentTypeName") ? "" : undefined,
                                columns.find((element) => element?.field === "number") ? "" : undefined,
                                columns.find((element) => element?.field === "totalNetValue") ? getGreekCurrencyFormat(totalNetValue) : undefined,
                                columns.find((element) => element?.field === "vatAmount") ? getGreekCurrencyFormat(totalVatValue) : undefined,
                                columns.find((element) => element?.field === "vat24") ? getGreekCurrencyFormat(totalVat24) : undefined,
                                columns.find((element) => element?.field === "vat13") ? getGreekCurrencyFormat(totalVat13) : undefined,
                                columns.find((element) => element?.field === "vat6") ? getGreekCurrencyFormat(totalVat6) : undefined,
                                columns.find((element) => element?.field === "vat17") ? getGreekCurrencyFormat(totalVat17) : undefined,
                                columns.find((element) => element?.field === "vat9") ? getGreekCurrencyFormat(totalVat9) : undefined,
                                columns.find((element) => element?.field === "vat4") ? getGreekCurrencyFormat(totalVat4) : undefined,
                                columns.find((element) => element?.field === "totalAmount") ? getGreekCurrencyFormat(totalValue) : undefined,
                                columns.find((element) => element?.field === "paymentTypeName") ? "" : undefined,
                                columns.find((element) => element?.field === "vehNumber") ? "" : undefined,
                                columns.find((element) => element?.field === "providerChannel") ? "" : undefined,
                                columns.find((element) => element?.field === "productNamesBalanceSheet") ? "" : undefined,
                                columns.find((element) => element?.field === "paymentAmount") ? getGreekCurrencyFormat(totalPaymentAmount) : undefined,
                                columns.find((element) => element?.field === "mark") ? "" : undefined,
                                columns.find((element) => element?.field === "country") ? "" : undefined,
                            ]
                            rows.push(row.filter((item) => item !== undefined));
                        } else {
                            rows = [{no: "no record found"}];
                        }

                        autoTable(doc, {
                            startY: y,
                            head: [columnNames],
                            body: rows,
                            theme: "striped",
                            rowPageBreak: "avoid",
                            styles: {
                                font: "DejaVu Sans Normal",
                                fontStyle: "normal",
                                fontSize: 7.5,
                                cellPadding: 1.5,
                                valign: "middle",
                                halign: "left",
                                overflow: "linebreak",
                            },
                            headStyles: {
                                font: "DejaVu Sans Bold",
                                fontSize: 8,
                                halign: "center",
                                fillColor: [241, 253, 255],
                                textColor: [0, 0, 0]
                            },
                            columnStyles: {
                                0: { halign: "center", cellWidth: 18 },
                            },
                            didParseCell: (data) => {
                                if (data.row.index === rows.length - 1) {
                                    data.cell.styles.fillColor = [241, 253, 255];
                                    data.cell.styles.textColor = [0, 0, 0];
                                    data.cell.styles.font = "DejaVu Sans Bold";
                                }

                                if (data.cell.text && data.cell.text.some(t => t.includes('€'))) {
                                    data.cell.styles.halign = 'right';
                                }
                            }
                        });

                        const pageCount = doc.getNumberOfPages();
                        for (let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            doc.setFontSize(10);
                            doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                        }

                        if (printer) {
                            this.setState({iframeData: `${doc.output('bloburl')}`});
                        } else {
                            doc.save("Sales Balance Report.pdf");
                        }
                    } else if (res.data && res.data.status === "422") {
                        toast.error("Something went wrong. Please try again later!");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    toast.error("Something went wrong. Please try again later!");
                });
        } else if (this.props.tableName === "Buys Balance Sheet") {
            const tableColumns = this.state.tableColumns;
            const tableName = this.props.tableName;
            let requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                date_from: this.props.filters?.date_from,
                date_to: this.props.filters?.date_to,
                month: this.props.filters?.month ? this.props.filters?.month : "",
                supplierName: this.props.filters?.supplierName,
                invoiceType: this.props.filters?.invoiceType.map(el => el.value),
                paymentType: this.props.filters?.paymentType.map(el => el.value),
                carNumber: this.props.filters?.carNumber.map(el => el.value),
                numberFrom: this.props.filters?.numberFrom,
                numberTo: this.props.filters?.numberTo,
                preNumberFrom: this.props.filters?.preNumberFrom,
                preNumberTo: this.props.filters?.preNumberTo,
                amountFrom: this.props.filters?.amountFrom,
                amountTo: this.props.filters?.amountTo,
                notes: this.props.filters?.notes,
                installation: this.props.filters?.installation,
            }
            axios.post(process.env.REACT_APP_API_URL2 + `/report/export-report`, requestData, {
                headers: {"Content-Type": "application/json"}
            }).then((res) => {
                let dR = [];
                if (res.data && res.data.status === "200") {
                    if (res.data.data.length > 0) {
                        res.data.data.forEach((element) => {
                            let obj = element;
                            obj.number = obj.number.replace("noprefix", "");
                            dR.push(obj);
                        });
                    }
                    const doc = new jsPDF('landscape');
                    this.setState({loader: false});
                    let y = 20;

                    doc.addFileToVFS("arialuni.ttf", liberationSerif);
                    doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                    doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                    doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                    doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                    doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
                    doc.setFont("DejaVu Sans Bold");
                    doc.setFontSize(17);
                    const header = doc.splitTextToSize("Ανάλυση Αγορών", 200);
                    const headerString = header.join("\n");
                    doc.text(headerString, doc.internal.pageSize.getWidth() / 2.5, 9, {alignment: "center"});

                    hookCompanyLogo(doc, this.props.companyDetails);

                    const imgData = 'assets/images/prrimer-logo.png';
                    const imgWidth = 28;
                    const imgHeight = 10;
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const pageHeight = doc.internal.pageSize.getHeight();
                    doc.addImage(imgData, 'PNG', pageWidth - imgWidth - 10, pageHeight - imgHeight - 5, imgWidth, imgHeight);
                    doc.setFont("DejaVu Sans Normal");
                    doc.setFontSize(11);
                    doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY HH:mm:ss")}`, 15, 18, {alignment: "center"});

                    const columns = tableColumns.map(column => {
                        if (column.field !== "actions" && column.field !== "no" && !column.hiddenColumn) {
                            return column;
                        }
                        return null;
                    }).filter(Boolean);

                    let columnNames = ["Ημερομηνία", "Προμηθευτής", "ΑΦΜ Προμηθευτή", "Τύπος Παραστατικού", "Αρίθμηση", "Καθαρή Εκπ. Αξία", "Μη Καθαρή Εκπ. Αξία", "Αξία Εκπ. Φ.Π.Α.", "Αξία Μη Εκπ. Φ.Π.Α.", "Συνολική Αξία"]

                    let rows;
                    let totalDeductibleNetValue = 0;
                    let totalNonDeductibleNetValue = 0;
                    let totalDeductibleVAT = 0;
                    let totalNonDeductibleVAT = 0;
                    let totalValue = 0;

                    if (dR.length > 0) {
                        rows = dR.map((movement) => {
                            totalDeductibleNetValue += movement.totalDeductibleNetValue;
                            totalNonDeductibleNetValue += movement.totalNonDeductibleNetValue;
                            totalDeductibleVAT += movement.totalDeductibleVAT;
                            totalNonDeductibleVAT += movement.totalNonDeductibleVAT;
                            totalValue = totalValue + movement.totalAmount;
                            let row = [
                                moment(movement.date).format("DD/MM/YYYY"),
                                columns.find((element) => element?.field === "supplierCode") ? movement.supplierCode : "",
                                columns.find((element) => element?.field === "supplierName") ? movement.supplierName : "",
                                columns.find((element) => element?.field === "vat") ? movement.vat : "",
                                columns.find((element) => element?.field === "documentTypeName") ? movement.documentTypeName : "",
                                columns.find((element) => element?.field === "number") ? movement.number : "",
                                columns.find((element) => element?.field === "totalDeductibleNetValue") ? getGreekCurrencyFormat(movement.totalDeductibleNetValue) : "",
                                columns.find((element) => element?.field === "totalNonDeductibleNetValue") ? getGreekCurrencyFormat(movement.totalNonDeductibleNetValue) : "",
                                columns.find((element) => element?.field === "totalDeductibleVAT") ? getGreekCurrencyFormat(movement.totalDeductibleVAT) : "",
                                columns.find((element) => element?.field === "totalNonDeductibleVAT") ? getGreekCurrencyFormat(movement.totalNonDeductibleVAT) : "",
                                columns.find((element) => element?.field === "totalAmount") ? getGreekCurrencyFormat(movement.totalAmount) : "",
                                columns.find((element) => element?.field === "paymentTypeName") ? movement.paymentTypeName : "",
                                columns.find((element) => element?.field === "vehNumber") ? movement.vehNumber : "",
                            ]
                            return row.filter((item) => item !== undefined);
                        });
                        rows.push([
                            "",
                            columns.find((element) => element?.field === "supplierCode") ? "" : "",
                            columns.find((element) => element?.field === "supplierName") ? "Συνολικά Ποσά" : "",
                            columns.find((element) => element?.field === "vat") ? "" : "",
                            columns.find((element) => element?.field === "documentTypeName") ? "" : "",
                            columns.find((element) => element?.field === "number") ? "" : "",
                            columns.find((element) => element?.field === "totalDeductibleNetValue") ? getGreekCurrencyFormat(totalDeductibleNetValue) : "",
                            columns.find((element) => element?.field === "totalNonDeductibleNetValue") ? getGreekCurrencyFormat(totalNonDeductibleNetValue) : "",
                            columns.find((element) => element?.field === "totalDeductibleVAT") ? getGreekCurrencyFormat(totalDeductibleVAT) : "",
                            columns.find((element) => element?.field === "totalNonDeductibleVAT") ? getGreekCurrencyFormat(totalNonDeductibleVAT) : "",
                            columns.find((element) => element?.field === "totalAmount") ? getGreekCurrencyFormat(totalValue) : "",
                            columns.find((element) => element?.field === "paymentTypeName") ? "" : "",
                            columns.find((element) => element?.field === "vehNumber") ? "" : "",
                        ])
                    } else {
                        rows = [{no: "no record found"}];
                    }

                    autoTable(doc, {
                        startY: y,
                        head: [columnNames],
                        body: rows,
                        theme: "striped",
                        rowPageBreak: "avoid",
                        styles: {
                            font: "DejaVu Sans Normal",
                            fontStyle: "normal",
                            fontSize: 7.5,
                            cellPadding: 1.5,
                            valign: "middle",
                            halign: "left",
                            overflow: "linebreak",
                        },
                        headStyles: {
                            font: "DejaVu Sans Bold",
                            fontSize: 8,
                            halign: "center",
                            fillColor: [241, 253, 255],
                            textColor: [0, 0, 0]
                        },
                        columnStyles: {
                            0: { halign: "center", cellWidth: 18 },
                        },
                        didParseCell: (data) => {
                            if (data.row.index === rows.length - 1) {
                                data.cell.styles.fillColor = [241, 253, 255];
                                data.cell.styles.textColor = [0, 0, 0];
                                data.cell.styles.font = "DejaVu Sans Bold";
                            }

                            if (data.cell.text && data.cell.text.some(t => t.includes('€'))) {
                                data.cell.styles.halign = 'right';
                            }
                        }
                    });

                    const pageCount = doc.getNumberOfPages();
                    for (let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        doc.setFontSize(10);
                        doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                    }

                    if (printer) {
                        this.setState({iframeData: `${doc.output('bloburl')}`});
                    } else {
                        doc.save("Buys Balance Report.pdf");
                    }
                } else if (res.data && res.data.status === "422") {
                    toast.error("Something went wrong. Please try again later!");
                }
            }).catch((error) => {
                console.log(error);
                toast.error("Something went wrong. Please try again later!");
            })
        } else if (this.props.tableName === "Client Payments Report") {
            const tableColumns = this.state.tableColumns;
            const tableName = this.props.tableName;
            let requestData = {
                company: this.props.company.id,
                year: String(this.props.company.year),
                columns: tableColumns,
                tableName: tableName,
                date_from: this.props.filters?.date_from ? this.props.filters?.date_from : "",
                date_to: this.props.filters?.date_to ? this.props.filters?.date_to : "",
                clientName: this.props.filters?.clientName ? this.props.filters?.clientName : "",
                invoiceType: this.props.filters?.invoiceType ? this.props.filters?.invoiceType.map(el => el.value) : [],
                paymentType: this.props.filters?.paymentType ? this.props.filters?.paymentType.map(el => el.value) : [],
                numberFrom: this.props.filters?.numberFrom ?? "",
                numberTo: this.props.filters?.numberTo ?? "",
            }
            axios.post(process.env.REACT_APP_API_URL2 + `/report/export-report`, requestData, {
                headers: {"Content-Type": "application/json"}
            })
                .then((res) => {
                    let dR = [];
                    if (res.data && res.data.status === "200") {
                        if (res.data.data.length > 0) {
                            res.data.data.forEach((element, j) => {
                                element.no = j + 1;
                                element.number = element.number.replace("noprefix", "");
                                dR.push(element);
                            });
                        }
                        const doc = new jsPDF('landscape');
                        this.setState({loader: false});
                        let y = 20;

                        doc.addFileToVFS("arialuni.ttf", liberationSerif);
                        doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                        doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                        doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                        doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                        doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
                        doc.setFont("DejaVu Sans Bold");
                        doc.setFontSize(17);
                        const header = doc.splitTextToSize("Ανάλυση Εισπράξεων", 200);
                        const headerString = header.join("\n");
                        doc.text(headerString, doc.internal.pageSize.getWidth() / 2.5, 9, {alignment: "center"});

                        hookCompanyLogo(doc, this.props.companyDetails);

                        const imgData = 'assets/images/prrimer-logo.png';
                        const imgWidth = 28;
                        const imgHeight = 10;
                        const pageWidth = doc.internal.pageSize.getWidth();
                        const pageHeight = doc.internal.pageSize.getHeight();
                        doc.addImage(imgData, 'PNG', pageWidth - imgWidth - 10, pageHeight - imgHeight - 5, imgWidth, imgHeight);
                        doc.setFont("DejaVu Sans Normal");
                        doc.setFontSize(11);
                        doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY HH:mm:ss")}`, 15, 18, {alignment: "center"});

                        let columnNames = [
                            "Αρ.",
                            "Ημ/νια",
                            "Όνομα Πελάτη",
                            "ΑΦΜ Πελάτη",
                            "Τύπος Παραστατικού",
                            "Αρίθμηση",
                            "Ποσό",
                            "Τρόπος Πληρωμής"
                        ]
                        let rows = [];
                        if (dR.length > 0) {
                            let totalPaymentAmount = 0;
                            for (let movement of dR) {
                                rows.push([
                                    movement.no,
                                    moment(movement.date).format("DD/MM/YYYY"),
                                    movement.clientName,
                                    movement.vatNumber,
                                    movement.documentTypeName,
                                    movement.preNumber === "noprefix" ? movement.number : movement.preNumber + " " + movement.number,
                                    getGreekCurrencyFormat(movement.amount),
                                    movement.paymentTypeName
                                ])
                                totalPaymentAmount += movement.amount;
                            }
                            rows.push([
                                "",
                                "",
                                "Συνολικά Ποσά",
                                "",
                                "",
                                "",
                                getGreekCurrencyFormat(totalPaymentAmount),
                                ""
                            ])
                        } else {
                            rows = [{no: "no record found"}];
                        }

                        autoTable(doc, {
                            startY: y,
                            head: [columnNames],
                            body: rows,
                            theme: "striped",
                            rowPageBreak: "avoid",
                            styles: {
                                font: "DejaVu Sans Normal",
                                fontStyle: "normal",
                                fontSize: 7.5,
                                cellPadding: 1.5,
                                valign: "middle",
                                halign: "left",
                                overflow: "linebreak",
                            },
                            headStyles: {
                                font: "DejaVu Sans Bold",
                                fontSize: 8,
                                halign: "center",
                                fillColor: [241, 253, 255],
                                textColor: [0, 0, 0]
                            },
                            columnStyles: {
                                0: { halign: "center", cellWidth: 18 },
                            },
                            didParseCell: (data) => {
                                if (data.row.index === rows.length - 1) {
                                    data.cell.styles.fillColor = [241, 253, 255];
                                    data.cell.styles.textColor = [0, 0, 0];
                                    data.cell.styles.font = "DejaVu Sans Bold";
                                }

                                if (data.cell.text && data.cell.text.some(t => t.includes('€'))) {
                                    data.cell.styles.halign = 'right';
                                }
                            }
                        });

                        const pageCount = doc.getNumberOfPages();
                        for (let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            doc.setFontSize(10);
                            doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                        }

                        if (printer) {
                            this.setState({iframeData: `${doc.output('bloburl')}`});
                        } else {
                            doc.save("Client Payment Report.pdf");
                        }
                    } else if (res.data && res.data.status === "422") {
                        toast.error("Something went wrong. Please try again later!");
                    }
                }).catch((error) => {
                console.log(error);
                toast.error("Something went wrong. Please try again later!");
            });
        } else if (this.props.tableName === "Supplier Payments Report") {
            const tableColumns = this.state.tableColumns;
            const tableName = this.props.tableName;
            let requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                date_from: this.props.filters?.date_from ? this.props.filters?.date_from : "",
                date_to: this.props.filters?.date_to ? this.props.filters?.date_to : "",
                supplierName: this.props.filters?.supplierName ? this.props.filters?.supplierName : "",
                invoiceType: this.props.filters?.invoiceType ? this.props.filters?.invoiceType.map(el => el.value) : [],
                paymentType: this.props.filters?.paymentType ? this.props.filters?.paymentType.map(el => el.value) : [],
                numberFrom: this.props.filters?.numberFrom ?? "",
                numberTo: this.props.filters?.numberTo ?? "",
                amountFrom: this.props.filters?.amountFrom ?? "",
                amountTo: this.props.filters?.amountTo ?? "",
            }
            axios.post(process.env.REACT_APP_API_URL2 + `/report/export-report`, requestData, {
                headers: {"Content-Type": "application/json"}
            }).then((res) => {
                let dR = [];
                if (res.data && res.data.status === "200") {
                    if (res.data.data.length > 0) {
                        res.data.data.forEach((element, j) => {
                            element.no = j + 1;
                            element.number = element.number.replace("noprefix", "");
                            dR.push(element);
                        });
                    }
                    const doc = new jsPDF('landscape');
                    this.setState({loader: false});
                    let y = 20;

                    doc.addFileToVFS("arialuni.ttf", liberationSerif);
                    doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                    doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                    doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                    doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                    doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
                    doc.setFont("DejaVu Sans Bold");
                    doc.setFontSize(17);
                    const header = doc.splitTextToSize("Ανάλυση Πληρωμών", 200);
                    const headerString = header.join("\n");
                    doc.text(headerString, doc.internal.pageSize.getWidth() / 2.5, 9, {alignment: "center"});

                    hookCompanyLogo(doc, this.props.companyDetails);

                    const imgData = 'assets/images/prrimer-logo.png';
                    const imgWidth = 28;
                    const imgHeight = 10;
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const pageHeight = doc.internal.pageSize.getHeight();
                    doc.addImage(imgData, 'PNG', pageWidth - imgWidth - 10, pageHeight - imgHeight - 5, imgWidth, imgHeight);
                    doc.setFont("DejaVu Sans Normal");
                    doc.setFontSize(11);
                    doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY HH:mm:ss")}`, 15, 18, {alignment: "center"});

                    // --- TABLE PREPARATION ---
                    let columnNames = [
                        "Αρ.",
                        "Ημ/νια",
                        "Όνομα Προμηθευτή",
                        "ΑΦΜ Προμηθευτή",
                        "Τύπος Παραστατικού",
                        "Αρίθμηση",
                        "Ποσό",
                        "Τρόπος Πληρωμής"
                    ];
                    let rows = [];
                    let totalPaymentAmount = 0;
                    if (dR.length > 0) {
                        for (let movement of dR) {
                            rows.push([
                                movement.no,
                                moment(movement.date).format("DD/MM/YYYY"),
                                movement.supplierName,
                                movement.vatNumber,
                                movement.documentTypeName,
                                movement.preNumber === "noprefix" ? movement.number : movement.preNumber + " " + movement.number,
                                getGreekCurrencyFormat(movement.amount),
                                movement.paymentTypeName
                            ])
                            totalPaymentAmount += movement.amount;
                        }
                        rows.push([
                            "",
                            "",
                            "Συνολικά Ποσά",
                            "",
                            "",
                            "",
                            getGreekCurrencyFormat(totalPaymentAmount),
                            ""
                        ])
                    } else {
                        rows = [{no: "no record found"}];
                    }

                    autoTable(doc, {
                        startY: y,
                        head: [columnNames],
                        body: rows,
                        theme: "striped",
                        rowPageBreak: "avoid",
                        styles: {
                            font: "DejaVu Sans Normal",
                            fontStyle: "normal",
                            fontSize: 7.5,
                            cellPadding: 1.5,
                            valign: "middle",
                            halign: "left",
                            overflow: "linebreak",
                        },
                        headStyles: {
                            font: "DejaVu Sans Bold",
                            fontSize: 8,
                            halign: "center",
                            fillColor: [241, 253, 255],
                            textColor: [0, 0, 0]
                        },
                        columnStyles: {
                            0: { halign: "center", cellWidth: 18 },
                        },
                        didParseCell: (data) => {
                            if (data.row.index === rows.length - 1) {
                                data.cell.styles.fillColor = [241, 253, 255];
                                data.cell.styles.textColor = [0, 0, 0];
                                data.cell.styles.font = "DejaVu Sans Bold";
                            }

                            if (data.cell.text && data.cell.text.some(t => t.includes('€'))) {
                                data.cell.styles.halign = 'right';
                            }
                        }
                    });

                    const pageCount = doc.getNumberOfPages();
                    for (let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        doc.setFontSize(10);
                        doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                    }

                    if (printer) {
                        this.setState({iframeData: `${doc.output('bloburl')}`});
                    } else {
                        doc.save("Supplier Payment Report.pdf");
                    }
                } else if (res.data && res.data.status === "422") {
                    toast.error("Something went wrong. Please try again later!");
                }
            }).catch((error) => {
                console.log(error);
                toast.error("Something went wrong. Please try again later!");
            });
        } else if (this.props.tableName === "Client Balance Report") {
            const tableColumns = this.state.tableColumns;
            const tableName = this.props.tableName;
            let requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                date_to: this.props.filters?.date_to ? this.props.filters?.date_to : "",
                clientName: this.props.filters?.clientName ? this.props.filters?.clientName : "",
                showZeroBalance: this.props.filters?.showZeroBalance,
                showInActive: this.props.filters?.showInActive,
                includeSettlements: this.props.filters?.includeSettlements,
            }
            axios.post(process.env.REACT_APP_API_URL2 + `/report/export-report`, JSON.stringify(requestData), {
                headers: {"Content-Type": "application/json"}
            })
                .then((res) => {
                    let dR = [];
                    if (res.data && res.data.status === "200") {
                        if (res.data.data.length > 0) {
                            res.data.data.forEach((element, i) => {
                                let obj = element;
                                obj.no = i + 1;
                                dR.push(obj);
                            });
                        }
                    } else {
                        if (res.data && res.data.message) {
                            toast.error(res.data && res.data.message);
                        } else {
                            toast.error(res.data && res.data.error);
                        }
                    }
                    const doc = new jsPDF('landscape');
                    this.setState({loader: false});
                    let y = 20;

                    doc.addFileToVFS("arialuni.ttf", liberationSerif);
                    doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                    doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                    doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                    doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                    doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");

                    hookCompanyLogo(doc, this.props.companyDetails);

                    const imgData = 'assets/images/prrimer-logo.png';
                    const primerWidth = 28;
                    const primerHeight = 10;
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const pageHeight = doc.internal.pageSize.getHeight();
                    doc.addImage(imgData, 'PNG', pageWidth - primerWidth - 10, pageHeight - primerHeight - 5, primerWidth, primerHeight);
                    doc.setFont("DejaVu Sans Bold");
                    doc.setFontSize(17);
                    const header = doc.splitTextToSize("Υπόλοιπο Πελατών", 200);
                    const headerString = header.join("\n");
                    doc.text(headerString, doc.internal.pageSize.getWidth() / 2.5, 9, {alignment: "center"});

                    doc.setFont("DejaVu Sans Normal");
                    doc.setFontSize(11);
                    doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY HH:mm:ss")}`, 15, 18, {alignment: "center"});

                    doc.setFont("DejaVu Sans Normal");
                    let columns = [];
                    if (res.data?.includeSettlements === "active") {
                        columns = ["Απογραφή", "Όνομα Πελάτη", "Α.Φ.Μ. Πελάτη", "Υπόλοιπο", "Διακανονισμένο ποσό", "Υπόλοιπο μετά διακανονισμών"];
                    } else {
                        columns = ["Απογραφή", "Όνομα Πελάτη", "Α.Φ.Μ. Πελάτη", "Υπόλοιπο"];
                    }
                    let rows;
                    let totalBalance = 0;
                    let totalSettledAmount = 0;
                    let totalBalanceWithSettledAmount = 0;
                    if (dR.length > 0) {
                        rows = dR.map((movement) => {
                            totalBalance += movement.balance;
                            if (res.data?.includeSettlements === "active") {
                                totalSettledAmount += movement.totalSettledAmount;
                                totalBalanceWithSettledAmount += movement.balanceWithSettledAmount;
                                return [
                                    getGreekCurrencyFormat(movement.census),
                                    movement.clientName,
                                    movement.vatNumber,
                                    getGreekCurrencyFormat(movement.balance),
                                    getGreekCurrencyFormat(movement.totalSettledAmount),
                                    getGreekCurrencyFormat(movement.balanceWithSettledAmount),
                                ]
                            } else {
                                return [
                                    getGreekCurrencyFormat(movement.census),
                                    movement.clientName,
                                    movement.vatNumber,
                                    getGreekCurrencyFormat(movement.balance),
                                ]
                            }
                        })
                        if (res.data?.includeSettlements === "active") {
                            rows.push([
                                "",
                                "Συνολικό Υπόλοιπο Πελατών",
                                "",
                                getGreekCurrencyFormat(totalBalance),
                                getGreekCurrencyFormat(totalSettledAmount),
                                getGreekCurrencyFormat(totalBalanceWithSettledAmount),
                            ])
                        } else {
                            rows.push([
                                "",
                                "Συνολικό Υπόλοιπο Πελατών",
                                "",
                                getGreekCurrencyFormat(totalBalance)
                            ])
                        }
                    } else {
                        rows = [{no: "no record found"}];
                    }

                    autoTable(doc, {
                        startY: y,
                        head: [columns],
                        body: rows,
                        theme: "striped",
                        rowPageBreak: "avoid",
                        styles: {
                            font: "DejaVu Sans Normal",
                            fontStyle: "normal",
                            fontSize: 7.5,
                            cellPadding: 1.5,
                            valign: "middle",
                            halign: "left",
                            overflow: "linebreak",
                        },
                        headStyles: {
                            font: "DejaVu Sans Bold",
                            fontSize: 8,
                            halign: "center",
                            fillColor: [241, 253, 255],
                            textColor: [0, 0, 0]
                        },
                        columnStyles: {
                            0: { halign: "center", cellWidth: 18 },
                        },
                        didParseCell: (data) => {
                            if (data.row.index === rows.length - 1) {
                                data.cell.styles.fillColor = [241, 253, 255];
                                data.cell.styles.textColor = [0, 0, 0];
                                data.cell.styles.font = "DejaVu Sans Bold";
                            }

                            if (data.cell.text && data.cell.text.some(t => t.includes('€'))) {
                                data.cell.styles.halign = 'right';
                            }
                        }
                    });

                    const pageCount = doc.getNumberOfPages();
                    for (let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        doc.setFontSize(10);
                        doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                    }

                    if (printer) {
                        this.setState({iframeData: `${doc.output('bloburl')}`});
                    } else {
                        doc.save("Client Balance Report.pdf");
                    }
                })
                .catch((error) => {
                    toast.error("Something went wrong. Please try again later!");
                    console.log(error);
                });
        } else if (this.props.tableName === "Supplier Balance Report") {
            const tableColumns = this.state.tableColumns;
            let requestData = {
                columns: tableColumns,
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                tableName: "Supplier Balance Report",
                ...this.props.filters,
                page: -1,
            }
            axios.post(process.env.REACT_APP_API_URL2 + `/report/export-report`, requestData, {
                headers: {"Content-Type": "application/json"}
            })
                .then((res) => {
                    let dR = [];
                    if (res.data && res.data.status === "200") {
                        if (res.data.data.length > 0) {
                            dR = res.data.data;
                        }
                    } else {
                        if (res.data && res.data.message) {
                            toast.error(res.data && res.data.message);
                        } else {
                            toast.error(res.data && res.data.error);
                        }
                    }
                    const doc = new jsPDF('landscape');
                    this.setState({loader: false});
                    let y = 20;

                    doc.addFileToVFS("arialuni.ttf", liberationSerif);
                    doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                    doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                    doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                    doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                    doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");

                    hookCompanyLogo(doc, this.props.companyDetails);

                    const imgData = 'assets/images/prrimer-logo.png';
                    const imgWidth = 28;
                    const imgHeight = 10;
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const pageHeight = doc.internal.pageSize.getHeight();
                    doc.addImage(imgData, 'PNG', pageWidth - imgWidth - 10, pageHeight - imgHeight - 5, imgWidth, imgHeight);
                    doc.setFont("DejaVu Sans Bold");
                    doc.setFontSize(17);
                    const header = doc.splitTextToSize("Υπόλοιπο Προμηθευτών", 200);
                    const headerString = header.join("\n");
                    doc.text(headerString, doc.internal.pageSize.getWidth() / 2.5, 9, {alignment: "center"});
                    doc.setFont("DejaVu Sans Normal");
                    doc.setFontSize(11);
                    doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY HH:mm:ss")}`, 15, 18, {alignment: "center"});

                    const columns = ["Απογραφή", "Όνομα Προμηθευτή", "Α.Φ.Μ. Προμηθευτή", "Υπόλοιπο"];
                    let rows;
                    let totalBalance = 0;
                    if (dR.length > 0) {
                        rows = dR.map((movement) =>
                            {
                                totalBalance = totalBalance + Number(movement.balance);
                                return [
                                    getGreekCurrencyFormat(movement.census),
                                    movement.supplierName,
                                    movement.vatNumber,
                                    getGreekCurrencyFormat(movement.balance),
                                ]
                            }
                        );
                        rows.push([
                            "",
                            "Συνολικό Υπόλοιπο Προμηθευτών",
                            "",
                            getGreekCurrencyFormat(totalBalance)
                        ])
                    } else {
                        rows = [{no: "No data found"}];
                    }
                    autoTable(doc, {
                        startY: y,
                        head: [columns],
                        body: rows,
                        theme: "striped",
                        rowPageBreak: "avoid",
                        styles: {
                            font: "DejaVu Sans Normal",
                            fontStyle: "normal",
                            fontSize: 7.5,
                            cellPadding: 1.5,
                            valign: "middle",
                            halign: "left",
                            overflow: "linebreak",
                        },
                        headStyles: {
                            font: "DejaVu Sans Bold",
                            fontSize: 8,
                            valign: "middle",
                            halign: "left",
                            fillColor: [241, 253, 255],
                            textColor: [0, 0, 0]
                        },
                        columnStyles: {
                            0: { cellWidth: 30 },
                        },
                        didParseCell: (data) => {
                            if (data.row.index === rows.length - 1) {
                                data.cell.styles.fillColor = [241, 253, 255];
                                data.cell.styles.textColor = [0, 0, 0];
                                data.cell.styles.font = "DejaVu Sans Bold";
                            }
                        }
                    });

                    const pageCount = doc.getNumberOfPages();
                    for (let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        doc.setFontSize(10);
                        doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                    }

                    if (printer) {
                        this.setState({iframeData: `${doc.output('bloburl')}`});
                    } else {
                        doc.save("Supplier Balance Report.pdf");
                    }
                })
                .catch((error) => {
                    toast.error("Something went wrong. Please try again later!");
                    console.log(error);
                });
        } else if (this.props.tableName === "Client Isozygio Report" || this.props.tableName === "Supplier Isozygio Report") {
            const tableColumns = this.state.tableColumns;
            let reportTotals;
            let requestData = {
                columns: tableColumns,
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                tableName: this.props.tableName,
                ...this.props.filters,
                page: -1,
            }
            axios.post(process.env.REACT_APP_API_URL2 + `/report/export-report`, requestData, {
                headers: {"Content-Type": "application/json"}
            }).then((res) => {
                let dR = [];
                if (res.data && res.data.status === "200") {
                    reportTotals = res.data.totals;
                    if (res.data.data.length > 0) {
                        dR = res.data.data;
                    }
                } else {
                    if (res.data && res.data.message) {
                        toast.error(res.data && res.data.message);
                    } else {
                        toast.error(res.data && res.data.error);
                    }
                }

                const doc = new jsPDF('landscape');
                this.setState({loader: false});
                let y = 20;
                doc.addFileToVFS("arialuni.ttf", liberationSerif);
                doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");

                hookCompanyLogo(doc, this.props.companyDetails);

                const imgData = 'assets/images/prrimer-logo.png';
                const imgWidth = 28;
                const imgHeight = 10;
                const pageWidth = doc.internal.pageSize.getWidth();
                const pageHeight = doc.internal.pageSize.getHeight();
                doc.addImage(imgData, 'PNG', pageWidth - imgWidth - 10, pageHeight - imgHeight - 5, imgWidth, imgHeight);
                doc.setFont("DejaVu Sans Bold");
                doc.setFontSize(17);
                const header = doc.splitTextToSize(this.props.tableName === "Client Isozygio Report" ? "Ισοζύγιο Πελατών" : "Ισοζύγιο Προμηθευτών", 200);
                const headerString = header.join("\n");
                doc.text(headerString, doc.internal.pageSize.getWidth() / 2.5, 9, {alignment: "center"});
                doc.setFont("DejaVu Sans Normal");
                doc.setFontSize(11);
                doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY HH:mm:ss")}`, 15, 18, {alignment: "center"});

                doc.setFont("DejaVu Sans Normal");
                const columns = this.props.tableName === "Client Isozygio Report" ?
                    ["Από Μεταφορά", "Κωδικός Πελάτη", "Όνομα Πελάτη", "Α.Φ.Μ. Πελάτη", "Χρέωση", "Πίστωση", "Υπόλοιπο Περιόδου", "Συνολικό Υπόλοιπο"]
                    :
                    ["Από Μεταφορά", "Κωδικός Προμηθευτής", "Όνομα Προμηθευτή", "Α.Φ.Μ. Προμηθευτή", "Χρέωση", "Πίστωση", "Υπόλοιπο Περιόδου", "Συνολικό Υπόλοιπο"];
                let rows;
                if (dR.length > 0) {
                    rows = dR.map((row) => {
                        return [
                            getGreekCurrencyFormat(row.carryOverBalance),
                            row.code,
                            row.name,
                            row.vatNumber,
                            getGreekCurrencyFormat(row.debit),
                            getGreekCurrencyFormat(row.credit),
                            getGreekCurrencyFormat(row.balance),
                            getGreekCurrencyFormat(row.totalBalance),
                        ];
                    });
                    rows.push([
                        getGreekCurrencyFormat(reportTotals.totalCarryOverBalance),
                        "",
                        "Σύνολα Υπολοίπων",
                        "",
                        getGreekCurrencyFormat(reportTotals.totalDebit),
                        getGreekCurrencyFormat(reportTotals.totalCredit),
                        getGreekCurrencyFormat(reportTotals.totalPeriodBalance),
                        getGreekCurrencyFormat(reportTotals.totalBalanceTotal),
                    ]);
                } else {
                    rows = [{no: "no record found"}];
                }
                autoTable(doc, {
                    startY: y,
                    head: [columns],
                    body: rows,
                    theme: "striped",
                    rowPageBreak: "avoid",
                    styles: {
                        font: "DejaVu Sans Normal",
                        fontStyle: "normal",
                        fontSize: 7.5,
                        cellPadding: 1.5,
                        valign: "middle",
                        halign: "left",
                        overflow: "linebreak",
                    },
                    headStyles: {
                        font: "DejaVu Sans Bold",
                        fontSize: 8,
                        valign: "middle",
                        halign: "left",
                        fillColor: [241, 253, 255],
                        textColor: [0, 0, 0]
                    },
                    columnStyles: {
                        0: { cellWidth: 30 },
                    },
                    didParseCell: (data) => {
                        if (data.row.index === rows.length - 1) {
                            data.cell.styles.fillColor = [241, 253, 255];
                            data.cell.styles.textColor = [0, 0, 0];
                            data.cell.styles.font = "DejaVu Sans Bold";
                        }
                    }
                });
                const pageCount = doc.getNumberOfPages();
                for (let i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.setFontSize(10);
                    doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                }
                if (printer) {
                    this.setState({iframeData: `${doc.output('bloburl')}`});
                } else {
                    doc.save("Client Balance Report.pdf");
                }
            }).catch((error) => {
                toast.error("Something went wrong. Please try again later!");
                console.log(error);
            });
        } else if (this.props.tableName === "Emron Payments Report") {
            let tableColumns = this.state.tableColumns;
            let tableName = this.props.tableName;
            let requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                month: this.props.filters?.month ? this.props.filters?.month : "",
                clientName: this.props.filters?.clientName ? this.props.filters?.clientName : "",
                groupInstallations: this.props.filters.groupInstallations,
                groupClients: this.props.filters.groupClients,
                cardPayments: this.props.filters.cardPayments,
                showZero: this.props.filters.showZero,
                page: -1
            }
            axios.post(process.env.REACT_APP_API_URL2 + "/report/emron-payments-report", requestData, {
                headers: {"Content-Type": "application/json"}
            })
                .then((res) => {
                    if (res.data && res.data.status === "200") {
                        let dR = [];
                        if (res.data.data.length > 0) {
                            dR = res.data.data;
                        }
                        const doc = new jsPDF('landscape');
                        this.setState({loader: false});
                        let y = 20;
                        doc.addFileToVFS("arialuni.ttf", liberationSerif);
                        doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                        doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                        doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                        doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                        doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
                        doc.setFont("DejaVu Sans Bold");
                        doc.setFontSize(13);
                        const header = doc.splitTextToSize("Μηνιαίες Χρεώσεις", 200);
                        const headerString = header.join("\n"); // Join the array elements into a single string with line breaks
                        doc.text(headerString, doc.internal.pageSize.getWidth() / 2.5, 9, {alignment: "center"});
                        doc.setFont("DejaVu Sans Normal");
                        doc.setFontSize(11);
                        doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY HH:mm:ss")}`, 15, 18, {alignment: "center"});
                        const imgData = 'assets/images/prrimer-logo.png';
                        const imgX = doc.internal.pageSize.getWidth() - 45; // adjust the position as needed
                        const imgY = 3; // adjust the position as needed
                        doc.addImage(imgData, 'PNG', imgX, imgY, 40, 15);
                        doc.setFont("DejaVu Sans Normal");
                        tableColumns = tableColumns.filter((el) => el.field !== "actions" && !el.hiddenColumn)
                        let columnNames = [];
                        let columnFields = [];
                        for (let tb of tableColumns) {
                            columnNames.push(tb.name);
                            columnFields.push(tb.field);
                        }

                        let rows = [];
                        let totals = res.data.totals;
                        if (dR.length > 0) {
                            for (let movement of res.data.data) {
                                let resRow = [];
                                for (let col of columnFields) {
                                    if (res.data.months?.includes(col)) {
                                        resRow.push(getGreekCurrencyFormat(movement[col]));
                                    } else {
                                        resRow.push(movement[col]);
                                    }
                                }
                                rows.push(resRow);
                            }
                            if (totals && Object.keys(totals).length > 0) {
                                let totalsNetRow = [];
                                let totalsVatRow = [];
                                let totalsRow = [];
                                for (let col of columnFields) {
                                    if (res.data.months?.includes(col)) {
                                        totalsNetRow.push(getGreekCurrencyFormat(Number(totals[col])));
                                        totalsVatRow.push(getGreekCurrencyFormat(Number(totals[col] * 0.24)));
                                        totalsRow.push(getGreekCurrencyFormat(Number(totals[col] * 1.24)));
                                    } else {
                                        if (col === "installation") {
                                            totalsNetRow.push("Συνολική Καθαρή Αξία");
                                            totalsVatRow.push("Συνολική Αξία Φ.Π.Α.");
                                            totalsRow.push("Συνολική Αξία");
                                        } else {
                                            totalsNetRow.push("");
                                            totalsVatRow.push("");
                                            totalsRow.push("");
                                        }
                                    }
                                }
                                rows.push(totalsNetRow);
                                rows.push(totalsVatRow);
                                rows.push(totalsRow);
                            }
                        } else {
                            rows = [{no: "no record found"}];
                        }
                        autoTable(doc, {
                            startY: y,
                            head: [columnNames],
                            body: rows,
                            theme: "striped",
                            rowPageBreak: "avoid",
                            styles: {
                                font: "DejaVu Sans Normal",
                                fontStyle: "normal",
                                fontSize: 7.5,
                                cellPadding: 1.5,
                                valign: "middle",
                                halign: "left",
                                overflow: "linebreak",
                            },
                            headStyles: {
                                font: "DejaVu Sans Bold",
                                fontSize: 8,
                                halign: "center",
                                fillColor: [241, 253, 255],
                                textColor: [0, 0, 0]
                            },
                            columnStyles: {
                                0: { halign: "center", cellWidth: 18 },
                            },
                            didParseCell: (data) => {
                                if (data.row.index === rows.length - 1) {
                                    data.cell.styles.fillColor = [241, 253, 255];
                                    data.cell.styles.textColor = [0, 0, 0];
                                    data.cell.styles.font = "DejaVu Sans Bold";
                                }

                                if (data.cell.text && data.cell.text.some(t => t.includes('€'))) {
                                    data.cell.styles.halign = 'right';
                                }
                            }
                        });
                        const pageCount = doc.getNumberOfPages();
                        // Add the pagination to each page
                        for (let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            doc.setFontSize(10);
                            doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                        }
                        if (printer) {
                            this.setState({iframeData: `${doc.output('bloburl')}`});
                        } else {
                            doc.save("Μηνιαίες Χρεώσεις.pdf");
                        }
                    } else if (res.data && res.data.status === "422") {
                        toast.error("Something went wrong. Please try again later!");
                    }
                })
                .catch((error) => {
                    toast.error("Something went wrong. Please try again later!");
                    console.log(error);
                });
        } else if (this.props.tableName === "Client Subscriptions Report") {
            const tableColumns = this.state.tableColumns;
            const tableName = this.props.tableName;
            let requestData = {
                tableName: tableName,
                columns: tableColumns,
                company: this.props.company.id,
                user: JSON.parse(localStorage.getItem("user"))._id,
                filterClientName: this.props.filters?.filterClientName,
                filterSubscriptionNames: this.props.filters?.filterSubscriptionNames,
                startDateFrom: this.props.filters?.startDateFrom,
                startDateTo: this.props.filters?.startDateTo,
                activationDateFrom: this.props.filters?.activationDateFrom,
                activationDateTo: this.props.filters?.activationDateTo,
                status: this.props.filters?.status,
                page: -1,
            };
            axios.post(process.env.REACT_APP_API_URL2 + `/report/export-report`, requestData, {headers: {"Content-Type": "application/json"}})
                .then(async (res) => {
                    if (res.data && res.data.status === "200") {
                        const doc = new jsPDF('landscape');
                        this.setState({loader: false});
                        let y = 20;
                        doc.addFileToVFS("arialuni.ttf", liberationSerif);
                        doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                        doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                        doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                        doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                        doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
                        doc.setFont("DejaVu Sans Bold");
                        doc.setFontSize(17);
                        const header = doc.splitTextToSize("Συνδρομές", 200);
                        const headerString = header.join("\n"); // Join the array elements into a single string with line breaks
                        doc.text(headerString, doc.internal.pageSize.getWidth() / 2.5, 9, {alignment: "center"});
                        doc.setFont("DejaVu Sans Normal");
                        doc.setFontSize(11);
                        doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY HH:mm:ss")}`, 15, 18, {alignment: "center"});
                        const imgData = 'assets/images/prrimer-logo.png';
                        const imgX = doc.internal.pageSize.getWidth() - 45; // adjust the position as needed
                        const imgY = 3; // adjust the position as needed
                        doc.addImage(imgData, 'PNG', imgX, imgY, 40, 15);
                        doc.setFont("DejaVu Sans Normal");
                        const columnNames = ["Αρ.", "Όνομα Πελάτη", "Α.Φ.Μ Πελάτη", "Όνομα Συνδρομής", "Ημερομηνία Έναρξης", "Ημερομηνία Ενεργοποίησης", "Ημερομηνία Λήξης", "Κατάσταση", "Τιμή"];
                        let rows = [];
                        if(res.data.data.length > 0) {
                            res.data.data.forEach((row) => {
                                rows.push([row.no, row.clientName, row.clientVATNumber, row.subscriptionName, row.startDate, row.activatedDate, row.endDate, row.status, row.price]);
                            })
                        }
                        rows.push(["", "", "", "", "", "", "", "Συνολικό ποσό συνδρομών", this.props.totalSubscriptionSum ? this.props.totalSubscriptionSum.toLocaleString('de-DE', {minimumFractionDigits: 2, useGrouping: true, groupingSeparator: '.'}) : "0.00"])
                        autoTable(doc, {
                            startY: y,
                            head: [columnNames],
                            body: rows,
                            theme: "striped",
                            rowPageBreak: "avoid",
                            styles: {
                                font: "DejaVu Sans Normal",
                                fontStyle: "normal",
                                fontSize: 7.5,
                                cellPadding: 1.5,
                                valign: "middle",
                                halign: "left",
                                overflow: "linebreak",
                            },
                            headStyles: {
                                font: "DejaVu Sans Bold",
                                fontSize: 8,
                                halign: "center",
                                fillColor: [241, 253, 255],
                                textColor: [0, 0, 0]
                            },
                            columnStyles: {
                                0: { halign: "center", cellWidth: 18 },
                            },
                            didParseCell: (data) => {
                                if (data.row.index === rows.length - 1) {
                                    data.cell.styles.fillColor = [241, 253, 255];
                                    data.cell.styles.textColor = [0, 0, 0];
                                    data.cell.styles.font = "DejaVu Sans Bold";
                                }

                                if (data.cell.text && data.cell.text.some(t => t.includes('€'))) {
                                    data.cell.styles.halign = 'right';
                                }
                            }
                        });
                        const pageCount = doc.getNumberOfPages();
                        // Add the pagination to each page
                        for (let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            doc.setFontSize(10);
                            doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                        }
                        if (printer) {
                            this.setState({iframeData: `${doc.output('bloburl')}`});
                        } else {
                            doc.save("Client Subscriptions Report.pdf");
                        }
                    } else if (res.data && res.data.status === "422") {
                        toast.error("Something went wrong. Please try again later!");
                    }
                })
                .catch((error) => {
                    toast.error("Something went wrong. Please try again later!");
                    console.log(error);
                });
        } else if (this.props.tableName === "MyData Report" || this.props.tableName === "MyData Report Buys") {
            let requestData = {
                company: this.props.company.id,
                date_from: moment().startOf("month").format("DD/MM/YYYY"),
                date_to: moment().endOf("month").format("DD/MM/YYYY"),
                number_from: this.props.filters.number_from ?? "",
                number_to: this.props.filters.number_to ?? "",
                invoiceType: this.props.filters.invoiceType ?? [],
                showFilter: this.props.filters.showFilter ?? "all",
                invoicesFromChannel: this.props.filters.invoicesFromChannel ?? "all",
                totalSum_from: this.props.filters.totalSum_from ?? "",
                totalSum_to: this.props.filters.totalSum_to ?? "",
                showAccounting: this.props.filters.showAccounting ?? true,
                lastUpdate: this.props.filters.lastUpdate ?? "",
                marks: this.props.filters.marks ?? "",
                classificationTypes: this.props.filters.classificationTypes ?? [],
                classified: this.props.filters.classified ?? "",
                forExport: true
            }
            if (this.props.tableName === "MyData Report") {
                requestData["clientVAT"] = this.props.filters.clientVAT ?? "";
                requestData["showClients"] = this.props.filters.showClients ?? "";
                requestData["reportType"] = "sales";
            } else if (this.props.tableName === "MyData Report Buys") {
                requestData["supplierVAT"] = this.props.filters.supplierVAT ?? "";
                requestData["showSuppliers"] = this.props.filters.showSuppliers ?? "";
                requestData["reportType"] = "buys";
            }
            axios.post(process.env.REACT_APP_API_URL2 + `/report/fetch-mydata-report`, requestData, {headers: {"Content-Type": "application/json"}})
                .then(async (res) => {
                    if (res.data && res.data.status === "200") {
                        const data = res.data.data ?? [];
                        const totals = res.data.totals;
                        const doc = new jsPDF('landscape');
                        this.setState({loader: false});
                        let y = 20;
                        doc.addFileToVFS("arialuni.ttf", liberationSerif);
                        doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                        doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                        doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                        doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                        doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
                        doc.setFont("DejaVu Sans Bold");
                        doc.setFontSize(17);
                        const header = doc.splitTextToSize("Συνδρομές", 200);
                        const headerString = header.join("\n"); // Join the array elements into a single string with line breaks
                        doc.text(headerString, doc.internal.pageSize.getWidth() / 2.5, 9, {alignment: "center"});
                        doc.setFont("DejaVu Sans Normal");
                        doc.setFontSize(11);
                        doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY HH:mm:ss")}`, 15, 18, {alignment: "center"});
                        const imgData = 'assets/images/prrimer-logo.png';
                        const imgX = doc.internal.pageSize.getWidth() - 45; // adjust the position as needed
                        const imgY = 3; // adjust the position as needed
                        doc.addImage(imgData, 'PNG', imgX, imgY, 40, 15);
                        doc.setFont("DejaVu Sans Normal");
                        const columnNames = ["Ημερομηνία", "MARK", "Πελάτης", "ΑΦΜ Πελάτη", "Τύπος Παραστατικού", "Αρίθμηση", "Καθαρή Αξία", "Ποσό Φ.Π.Α.", "Συνολική Αξία", "Κατάσταση ERP", "Κατάσταση MyData", "Χαρ."];
                        let rows = [];
                        if(data.length > 0) {
                            data.forEach((row) => {
                                const date = row.date?.split("T")[0];
                                const classified = isEmpty(row.classified) || row.classified === "false" ? "Όχι" : row?.hasDifference ? "Ναι, με διαφορά" : "Ναι";
                                if (row.myDataStatus === "sent") row.myDataStatus = "Απεσταλμένο";
                                else if (row.myDataStatus === "not_sent") row.myDataStatus = "Μη Απεσταλμένο";
                                else if (row.myDataStatus === "aade_offline") row.myDataStatus = "Μη Απεσταλμένο (ΑΑΔΕ Εκτός Σύνδεσης)"
                                if (row.myDataSentStatus === "sent") row.myDataSentStatus = "Απεσταλμένο";
                                else if (row.myDataSentStatus === "not_sent") row.myDataSentStatus = "Μη Απεσταλμένο";
                                else if (row.myDataSentStatus === "aade_offline") row.myDataSentStatus = "Μη Απεσταλμένο (ΑΑΔΕ Εκτός Σύνδεσης)";

                                if (["5.1", "5.2", "11.4", "13.31", "14.31"].includes(row.myDataType) || (String(row.myDataType).startsWith("17.") && row?.classifications?.some((el) => el.recType === "7"))) {
                                    row.totalNetValue = `-${row.totalNetValue}`;
                                    row.totalVatValue = `-${row.totalVatValue}`;
                                    row.totalAmount = `-${row.totalAmount}`;
                                }
                                rows.push([date, row.mark, this.props.tableName === "sales" ? row.clientName : row.supplierName, row.vat, row.myDataType, row.number, row.totalNetValue, row.totalVatValue, row.totalAmount, row.myDataStatus, row.myDataSentStatus, classified]);
                            })
                        }
                        rows.push(["", "", "", "", "", "", "", "Σύνολα", "Σύνολα ERP", "Σύνολα MyData", "Διαφορές"]);
                        rows.push(["", "", "", "", "", "", "", "Συνολική Ποσότηα", totals.totalCount, totals.totalCountMyData, (Number(totals.totalCountMyData) - Number(totals.totalCount).toFixed(2))]);
                        rows.push(["", "", "", "", "", "", "", "Συνολική καθαρή Αξία", totals.totalNetValue, totals.totalNetValueMyData, (Number(totals.totalNetValueMyData) - Number(totals.totalNetValue)).toFixed(2)]);
                        rows.push(["", "", "", "", "", "", "", "Συνολικό Ποσό Φ.Π.Α.", totals.totalVatValue, totals.totalVatValueMyData, (Number(totals.totalVatValueMyData) - Number(totals.totalVatValue)).toFixed(2)]);
                        rows.push(["", "", "", "", "", "", "", "Συνολική Αξία", totals.totalValue, totals.totalValueMyData, (Number(totals.totalValueMyData) - Number(totals.totalValue)).toFixed(2)]);
                        autoTable(doc, {
                            startY: y,
                            head: [columnNames],
                            body: rows,
                            theme: "striped",
                            rowPageBreak: "avoid",
                            columnStyles: {
                                0: {cellWidth: 20},
                                1: {cellWidth: 35},
                                2: {cellWidth: 50},
                                11: {cellWidth: 10},
                                7: {cellWidth: 30},
                            },
                            styles: {
                                font: "DejaVu Sans Normal",
                                fontStyle: "normal",
                                fontSize: 8,
                                halign: "center",
                            },
                            didParseCell: (data) => {
                                // Check if the current row is a header row
                                if (data.row.raw === columnNames || data.row.index === rows.length - 1) {
                                    data.cell.styles.fillColor = [241, 253, 255]; // set fill color for the header row
                                    data.cell.styles.textColor = [0, 0, 0]; // set text color for the header row
                                    data.cell.styles.font = "DejaVu Sans Bold";
                                } else {
                                    data.cell.styles.textColor = [0, 0, 0]; // set text color for the header row
                                }
                            }
                        });
                        const pageCount = doc.getNumberOfPages();
                        // Add the pagination to each page
                        for (let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            doc.setFontSize(10);
                            doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                        }
                        if (printer) {
                            this.setState({iframeData: `${doc.output('bloburl')}`});
                        } else {
                            doc.save(this.props.tableName === "MyData Report" ? "MyData Sales Report.pdf" : "MyData Buys Report.pdf");
                        }
                    } else if (res.data && res.data.status === "422") {
                        toast.error("Something went wrong. Please try again later!");
                    }
                })
                .catch((error) => {
                    toast.error("Something went wrong. Please try again later!");
                    console.log(error);
                });
        } else if (this.props.tableName === "Companies AI usage report") {
            this.setState({loader: true});

            const requestPayload = {
                date_from: this.props.filters?.date_from || "",
                date_to: this.props.filters?.date_to || "",
                companies: this.props.filters?.companies || [],
                geminiCostFrom: this.props.filters?.geminiCostFrom || "",
                geminiCostTo: this.props.filters?.geminiCostTo || "",
                primerCostFrom: this.props.filters?.primerCostFrom || "",
                primerCostTo: this.props.filters?.primerCostTo || "",
                creditConversion: this.props.filters?.creditConversion || "",
                page: -1
            };

            axios.post(`${process.env.REACT_APP_API_URL2}/ai/companies-ai-usage-report`, requestPayload, {
                headers: {"Content-Type": "application/json"}
            }).then((res) => {
                if (res.data && res.status === 200) {
                    const dR = res.data.data;
                    const doc = new jsPDF('landscape');
                    this.setState({loader: false});

                    doc.addFileToVFS("arialuni.ttf", liberationSerif);
                    doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                    doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                    doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                    doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                    doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
                    doc.setFont("DejaVu Sans Normal");
                    doc.setFontSize(17);
                    const headerTitle = "Στατιστικά Χρήσης AI Ανά Εταιρεία";
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const pageHeight = doc.internal.pageSize.getHeight();
                    doc.text(headerTitle, pageWidth / 2, 12, {alignment: "center"});
                    doc.setFont("DejaVu Sans Normal");
                    doc.setFontSize(11);
                    doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY HH:mm:ss")}`, 15, 18);

                    const columnNames = ["Αρ.", "Εταιρεία", "ΑΦΜ", "ΑΙ Credits Files", "AI Credits myDATA", "AI Credits", "Αρ. Αρχείων", "Αρ. παρ. myDATA", "Σύνολο παραστατικών", "Κόστος Gemini", "Κόστος Primer"];
                    let rows = [];
                    let totalGemini = 0;
                    let totalTokens = 0;
                    let totalPrimer = 0;
                    let totalAiTokenFiles = 0;
                    let totalAiTokenMyData = 0;
                    let totalFilesCount = 0;
                    let totalMyDataCount = 0;
                    let totalDocumentCount = 0;

                    if (dR.length > 0) {
                        rows = dR.map((item, index) => {
                            totalAiTokenFiles += +item.aiTokensFiles || 0;
                            totalAiTokenMyData += +item.aiTokensMyData || 0;
                            totalTokens += +item.aiTokens || 0;
                            totalFilesCount += +item.filesCount || 0;
                            totalMyDataCount += +item.myDataCount || 0;
                            totalDocumentCount += +item.totalDocumentCount || 0;
                            totalGemini += +item.geminiCost || 0;
                            totalPrimer += +item.primerCost || 0;

                            return [
                                index + 1,
                                item.companyName,
                                item.companyVatNumber,
                                item.aiTokensFiles,
                                item.aiTokensMyData,
                                item.aiTokens,
                                item.filesCount,
                                item.myDataCount,
                                item.totalDocumentCount,
                                getGreekCurrencyFormat(item.geminiCost),
                                getGreekCurrencyFormat(item.primerCost)
                            ];
                        });

                        rows.push([
                            "", "ΣΥΝΟΛΑ", "",
                            totalAiTokenFiles,
                            totalAiTokenMyData,
                            totalTokens,
                            totalFilesCount,
                            totalMyDataCount,
                            totalDocumentCount,
                            getGreekCurrencyFormat(totalGemini),
                            getGreekCurrencyFormat(totalPrimer)
                        ]);
                    } else {
                        rows = [["", "Δεν βρέθηκαν αποτελέσματα", "", "", "", ""]];
                    }

                    autoTable(doc, {
                        startY: y,
                        head: [columnNames],
                        body: rows,
                        theme: "striped",
                        rowPageBreak: "avoid",
                        styles: {
                            font: "DejaVu Sans Normal",
                            fontStyle: "normal",
                            fontSize: 7.5,
                            cellPadding: 1.5,
                            valign: "middle",
                            halign: "left",
                            overflow: "linebreak",
                        },
                        headStyles: {
                            font: "DejaVu Sans Bold",
                            fontSize: 8,
                            halign: "center",
                            fillColor: [241, 253, 255],
                            textColor: [0, 0, 0]
                        },
                        columnStyles: {
                            0: { halign: "center", cellWidth: 18 },
                        },
                        didParseCell: (data) => {
                            if (data.row.index === rows.length - 1) {
                                data.cell.styles.fillColor = [241, 253, 255];
                                data.cell.styles.textColor = [0, 0, 0];
                                data.cell.styles.font = "DejaVu Sans Bold";
                            }

                            if (data.cell.text && data.cell.text.some(t => t.includes('€'))) {
                                data.cell.styles.halign = 'right';
                            }
                        }
                    });

                    const imgData = 'assets/images/prrimer-logo.png';
                    const imgWidth = 28;
                    const imgHeight = 10;
                    doc.addImage(imgData, 'PNG', pageWidth - imgWidth - 10, pageHeight - imgHeight - 5, imgWidth, imgHeight);
                    const pageCount = doc.getNumberOfPages();
                    for (let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        doc.setFontSize(10);
                        doc.text(`Σελίδα ${i} από ${pageCount}`, 10, pageHeight - 10);
                    }

                    if (printer) {
                        this.setState({iframeData: `${doc.output('bloburl')}`});
                    } else {
                        doc.save("Στατιστικά Χρήσης ΑΙ.pdf");
                    }
                } else {
                    this.setState({loader: false});
                    toast.error(res.data?.message || "Σφάλμα κατά την εξαγωγή.");
                }
            }).catch((error) => {
                this.setState({loader: false});
                console.error("PDF Export Error:", error);
                toast.error("Σφάλμα συστήματος κατά την εξαγωγή.");
            });
        }
    };
    handleExport = (exportType) => {
        const dataEndpoint = this.props.dataEndpoint;
        const exportFileName = this.props.exportFileName;
        const tableName = this.props.tableName;
        const company = this.props.requestData.company;
        const filterData = this.props.requestData;
        let tableColumns = this.state.tableColumns?.filter(el => !el.hiddenColumn && !["select_checkbox", "actions"].includes(el.field));
        this.setState({searchExportLoader: true});
        if (isEmpty(dataEndpoint) || isEmpty(exportFileName)) return toast.error("Data endpoint and file name are required.");

        /* ~~~~~~~~~~~~~~~~~~~~ Modify columns for prenumber and number ~~~~~~~~~~~~~~~~~*/
        if (tableColumns.some(el => el.field === "preNumberAndNumber")) {
            tableColumns = tableColumns.filter(el => el.field !== "preNumberAndNumber");
            tableColumns.push({name: "Αριθμός", field: "number", inputType: { type: "text" }});
        }
        if (tableColumns.some(el => el.field === "accountCategory")) {
            tableColumns.push({name: "", field: "isNetValue", inputType: { type: "text" }})
            tableColumns.push({name: "", field: "vat", inputType: { type: "text" }})
            tableColumns.push({name: "", field: "taxType", inputType: { type: "text" }})
        }
        let requestData = {
            company: company,
            columns: tableColumns,
            filterData: filterData,
            export: true,
            year: new Date().getFullYear(),
            sortOptions: this.props.sortOptions ? this.props.sortOptions[tableName] : null
        }
        axios.post(process.env.REACT_APP_API_URL2 + dataEndpoint, requestData, {
            headers: {'Content-Type': 'application/json'}
        }).then((res) => {
            if (res.data.status === "200") {
                if (res.data.data.length > 0) {
                    const data = res.data.data.map(({_id, ...data}) => data);
                    /* Modify Specific Fields - Fix Dates */
                    if (tableName === "Sales Search" || tableName === "Buys Search") {
                        data.forEach((el) => {
                            if (el.date) el.date = el.date.split(".")[0].replace("T", " ");
                            if (el.myDataStatus === "sent") el.myDataStatus = "Απεσταλμένο";
                            else if (el.myDataStatus === "not_sent") el.myDataStatus = "Μη Απεσταλμένο";
                            else if (el.myDataStatus === "aade_offline") el.myDataStatus = "Μη Απεσταλμένο (ΑΑΔΕ Εκτός Σύνδεσης)";
                            if (tableColumns.map(el => el.field).includes("paymentStatus")) {
                                if (el.paymentStatus === "paid") el.paymentStatus = "Εξοφλημένο";
                                else if (el.paymentStatus === "semipaid") el.paymentStatus = "Μερικώς Εξοφλημένο";
                                else if (el.paymentStatus === "unpaid") el.paymentStatus = "Ανεξόφλητο";
                            } else {
                                delete el.paymentStatus;
                            }
                        })
                    } else if (tableName === "Quotations Search") {
                        data.forEach((el) => {
                            if (el.date) el.date = el.date.split(".")[0].replace("T", " ");
                        })
                    } else if (tableName === "Search Products") {
                        tableColumns = tableColumns.filter(el => el.field !== "supplierName" && el.field !== "supplierCode" && el.field !== "tag");
                        data.forEach((el) => {
                            if (el.isActive === "active") el.isActive = "Ενεργό";
                            else if (el.isActive === "inactive") el.isActive = "Ανενεργό";
                        })
                    } else if (tableName === "Search Product Movements") {
                        data.forEach((el) => {
                            if (el.date) el.date = el.date.split(".")[0].replace("T", " ");
                        })
                    } else if (tableName === "Search Product Price List") {
                        data.forEach((el) => {
                            if (el.isActive === "active") el.isActive = "Ενεργό";
                            else if (el.isActive === "inactive") el.isActive = "Ανενεργό";
                        })
                    } else if (tableName === "Cash Registers Search") {
                        data.forEach((el) => {
                            if (el.date) el.date = el.date.split(".")[0].replace("T", " ");
                            if (el.isActive === "active") el.isActive = "Ενεργό";
                            else if (el.isActive === "inactive") el.isActive = "Ανενεργό";
                        })
                    } else if (tableName === "POS Search") {
                        data.forEach((el) => {
                            if (el.date) el.date = el.date.split(".")[0].replace("T", " ");
                            if (el.isETameiaki === "active") el.isETameiaki = "Ενεργό";
                            else if (el.isETameiaki === "inactive") el.isETameiaki = "Ανενεργό";
                        })
                    } else if (tableName === "Bank Account Search") {
                        data.forEach((el) => {
                            if (el.date) el.date = el.date.split(".")[0].replace("T", " ");
                            if (el.isSentToAade === "active") el.isSentToAade = "Ενεργό";
                            else if (el.isSentToAade === "no") el.isSentToAade = "Όχι";
                        })
                    } else if (tableName === "Client Payments Search" || tableName === "Supplier Payments Search") {
                        data.forEach((el) => {
                            if (el.date) el.date = el.date.split(".")[0].replace("T", " ");
                        })
                    } else if (tableName === "Client Search") {
                        tableColumns = tableColumns.filter(el => el.name !== "Όνομα επαφής");
                        data.forEach((el) => {
                            if (el.categoryName === "Freelancer") el.categoryName = "Ελεύθερος Επαγγελματίας";
                            else if (el.categoryName === "Retail") el.categoryName = "Πελάτης Λιανικής";
                            else if (el.categoryName === "O.E.") el.categoryName = "Ο.Ε.";
                            else if (el.categoryName === "E.E.") el.categoryName = "Ε.Ε.";
                            else if (el.categoryName === "E.P.E.") el.categoryName = "Ε.Π.Ε.";
                            else if (el.categoryName === "I.K.E.") el.categoryName = "Ι.Κ.Ε.";
                            else if (el.categoryName === "A.E.") el.categoryName = "Α.Ε.";
                            else if (el.categoryName === "Non-Profit Organization") el.categoryName = "Μή Κερδοσκοπική Οργάνωση";
                            else if (el.categoryName === "Wholesale Others") el.categoryName = "Λοιποί Χονδρικής";
                            else if (el.categoryName === "Client within E.U.") el.categoryName = "Πελάτης Εντός Ε.Ε.";
                            else if (el.categoryName === "Client outside E.U.") el.categoryName = "Πελάτης Εκτός Ε.Ε.";
                        })
                    } else if (tableName === "Supplier Search") {
                        tableColumns = tableColumns.filter(el => el.name !== "Όνομα επαφής");
                        data.forEach((el) => {
                            if (el.categoryName === "Freelancer") el.categoryName = "Ελεύθερος Επαγγελματίας";
                            else if (el.categoryName === "Retail") el.categoryName = "Προμηθευτής Λιανικής";
                            else if (el.categoryName === "O.E.") el.categoryName = "Ο.Ε.";
                            else if (el.categoryName === "E.E.") el.categoryName = "Ε.Ε.";
                            else if (el.categoryName === "E.P.E.") el.categoryName = "Ε.Π.Ε.";
                            else if (el.categoryName === "I.K.E.") el.categoryName = "Ι.Κ.Ε.";
                            else if (el.categoryName === "A.E.") el.categoryName = "Α.Ε.";
                            else if (el.categoryName === "Non-Profit Organization") el.categoryName = "Μή Κερδοσκοπική Οργάνωση";
                            else if (el.categoryName === "Wholesale Others") el.categoryName = "Λοιποί Χονδρικής";
                            else if (el.categoryName === "Client within E.U.") el.categoryName = "Προμηθευτής Εντός Ε.Ε.";
                            else if (el.categoryName === "Client outside E.U.") el.categoryName = "Προμηθευτής Εκτός Ε.Ε.";
                        })
                    } else if (tableName === "Employees Search") {
                        data.forEach((el) => {
                            if (el.birthDate) el.birthDate = el.birthDate.split("T")[0];
                            if (el.employmentDate) el.employmentDate = el.employmentDate.split("T")[0];
                            if (el.resignationDate) el.resignationDate = el.resignationDate.split("T")[0];
                            if (el.employeeType === "normal") el.employeeType = "Κανονικός";
                            else if (el.employeeType === "constructionWorker") el.employeeType = "Εργατοτεχνίτης Οικοδομικών Εργασιών";
                            else if (el.employeeType === "marine") el.employeeType = "Ναυτικός";
                            else if (el.employeeType === "professionalWithIka") el.employeeType = "Επαγγελματίας Με ΙΚΑ";
                            else if (el.employeeType === "special") el.employeeType = "Ειδική Κατηγορία";
                            else if (el.employeeType === "employeedByErgosimo") el.employeeType = "Απασχολούμενος με Εργόσημο";
                            else if (el.employeeType === "paidByDPY") el.employeeType = "Αμοιβόμενος με ΔΠΥ";
                            else if (el.employeeType === "marineOffice") el.employeeType = "Ναυτικός σε Γραφείο";
                            else if (el.employeeType === "hourly") el.employeeType = "Ωρομίσθιος";
                        })
                    } else if (tableName === "Accounting Account Search") {
                        data.forEach((el) => {
                            if (el.transferable === "active") el.transferable = "Ενεργό";
                            else if (el.transferable === "inactive") el.transferable = "Ανενεργό";
                            if (el.movable === "active") el.movable = "Ενεργό";
                            else if (el.movable === "inactive") el.movable = "Ανενεργό";
                            if (el.subAccount === "") el.subAccount = "Δεν υποστηρίζει";
                            else if (el.subAccount === "installation") el.subAccount = "Εγκαταστάσεις";
                            else if (el.subAccount === "client") el.subAccount = "Πελάτες";
                            else if (el.subAccount === "supplier") el.subAccount = "Προμηθευτές";
                            else if (el.subAccount === "employee") el.subAccount = "Εργαζόμενοι";
                            else if (el.subAccount === "bankAccount") el.subAccount = "Τραπεζικός Λογαριασμός";
                            else if (el.subAccount === "pos") el.subAccount = "POS";
                            else if (el.subAccount === "cashRegister") el.subAccount = "Ταμειακή Μηχανή";
                            else if (el.subAccount === "stockholder") el.subAccount = "Μέτοχος";
                            if (el.isNetValue !== "false") {
                                el.accountCategory = getIsNetValueOptions().find((obj) => obj.value === el.isNetValue)?.label;
                            } else if (el.vat) {
                                el.accountCategory = getMyData({
                                    type: 'vat',
                                    option: "doNotShowZero"
                                }).find((obj) => obj.value === el.vat)?.label;
                            } else {
                                el.accountCategory = getTaxTypeOptions().find((obj) => obj.value === el.taxType)?.label;
                            }
                            if (el.accountCategory === "Κενό") el.accountCategory = "";
                            delete el.isNetValue;
                            delete el.vat;
                            delete el.taxType;
                        })
                        tableColumns = tableColumns.filter(el => !["isNetValue", "vat", "taxType"].includes(el.field))
                    } else if (tableName === "Accounting Record Search") {
                        data.forEach((el) => {
                            if (el.date) el.date = el.date.split("T")[0];
                            if (el.myDataStatus === "sent") el.myDataStatus = "Απεσταλμένο";
                            else if (el.myDataStatus === "not_sent") el.myDataStatus = "Μη Απεσταλμένο";
                            else if (el.myDataStatus === "aade_offline") el.myDataStatus = "Μη Απεσταλμένο (ΑΑΔΕ Εκτός Σύνδεσης)";
                        })
                    } else if (tableName === "Dcl Search") {
                        data.forEach((el) => {
                            if (el.creationDateTime) el.creationDateTime = el.creationDateTime.split("T")[0];
                            if (!isEmpty(el?.status)) el.status = dclStatusOptions.find((op) => op.value === el.status)?.label;
                            if (!isEmpty(el?.clientServiceType)) el.clientServiceType = clientServiceTypes.find((op) => op.value === el.clientServiceType)?.label;
                            if (!isEmpty(el?.serviceCategory)) el.serviceCategory = [{value: "oneTime", label: "Άπαξ"}, {value: "recurring", label: "Επαναλαμβανόμενη"}, {value: "continuous", label: "Διαρκής"}].find((op) => op.value === el.serviceCategory)?.label;
                            if (!isEmpty(el?.providedServiceCategory)) el.providedServiceCategory = providedServiceCategoryOptions.find((op) => op.value === el.providedServiceCategory)?.label;
                            if (!isEmpty(el?.vehicleFactory)) el.vehicleFactory = `${el.vehicleFactory} - ${vehicleCategoryOptions.find((op) => op.value === el.vehicleCategory)?.label}`;
                        })
                    } else if (tableName === "Work Movements Search") {
                        data.forEach((el) => {
                            if (el.movementType) el.movementType = el.movementType === "arrive" ? "Προσέλευση" : "Αναχώρηση";
                            if (el.date) el.date = moment(el.date).format("DD/MM/YYYY HH:mm");
                        })
                    } else if (tableName === "Companies AI usage report") {
                        data.forEach((el) => {
                            el.geminiCost = !isEmpty(el.geminiCost) ? Number(el.geminiCost).toFixed(2) : "0.00";
                            el.primerCost = !isEmpty(el.primerCost) ? Number(el.primerCost).toFixed(2) : "0.00";
                            el.aiTokens = !isEmpty(el.aiTokens) ? Number(el.aiTokens) : 0;
                        });
                    } else if (tableName === "Submitted Vat Declarations Search") {
                        const monthNames = [
                            "", "Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος",
                            "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"
                        ];
                        const declTypeLabels = {
                            INITIAL: "Αρχική",
                            AMENDING: "Τροποποιητική",
                            WITH_RESERVATION: "Με Επιφύλαξη",
                            EXTRAORDINARY: "Έκτακτη"
                        };

                        data.forEach((el) => {
                            el.monthName = monthNames[Number(el.month)] || el.monthName || "-";
                            el.declarationTypeName = declTypeLabels[el.declarationType] || el.declarationTypeName || "Αρχική";

                            const raw311 = Number(el.field311 ?? el.fields?.['311'] ?? el.fields?.['0311'] ?? 0);
                            const raw367 = Number(el.field367 ?? el.fields?.['367'] ?? el.fields?.['0367'] ?? 0);
                            const raw470 = Number(el.fields?.['470'] ?? el.fields?.['0470'] ?? 0);
                            const raw480 = Number(el.fields?.['480'] ?? el.fields?.['0480'] ?? 0);

                            el.field311 = getGreekCurrencyFormat(raw311);
                            el.field367 = getGreekCurrencyFormat(raw367);

                            if (raw470 > 0) {
                                el.balanceFormatted = getGreekCurrencyFormat(raw470);
                            } else if (raw480 > 0) {
                                el.balanceFormatted = `-${getGreekCurrencyFormat(raw480)}`;
                            } else {
                                el.balanceFormatted = getGreekCurrencyFormat(0);
                            }
                        });
                    } else if (tableName === "Submitted F4 Declarations Search") {
                        const monthNames = [
                            "", "Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος",
                            "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"
                        ];
                        const declTypeLabels = {
                            INITIAL: "Αρχική",
                            AMENDING: "Διορθωτική / Τροποποιητική"
                        };

                        data.forEach((el) => {
                            el.monthName = monthNames[Number(el.month)] || el.monthName || "-";
                            el.declarationTypeName = declTypeLabels[el.declarationType] || el.declarationTypeName || "Αρχική";

                            const rawBc5 = Number(el.totalBc5 ?? el.totals?.bc5 ?? 0);
                            const rawBc6 = Number(el.totalBc6 ?? el.totals?.bc6 ?? 0);
                            const rawBc7 = Number(el.totalBc7 ?? el.totals?.bc7 ?? 0);
                            const rawBc8 = Number(el.totalBc8 ?? el.totals?.bc8 ?? 0);

                            el.totalBc5 = getGreekCurrencyFormat(rawBc5);
                            el.totalBc6 = getGreekCurrencyFormat(rawBc6);
                            el.totalBc7 = getGreekCurrencyFormat(rawBc7);
                            el.totalBc8 = getGreekCurrencyFormat(rawBc8);
                        });
                    } else if (tableName === "Submitted F5 Declarations search") {
                        const monthNames = [
                            "", "Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος",
                            "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"
                        ];
                        
                        const declTypeLabels = {
                            INITIAL: "Αρχική",
                            AMENDING: "Διορθωτική / Τροποποιητική"
                        };

                        data.forEach((el) => {
                            el.monthName = monthNames[Number(el.month)] || el.monthName || "-";
                            el.declarationTypeName = declTypeLabels[el.declarationType] || el.declarationTypeName || "Αρχική";

                            const rawBc5 = Number(el.totalBc5 ?? el.totals?.bc5 ?? 0);
                            const rawBc6 = Number(el.totalBc6 ?? el.totals?.bc6 ?? 0);
                            const rawBc7 = Number(el.totalBc7 ?? el.totals?.bc7 ?? 0);

                            el.totalBc5 = getGreekCurrencyFormat(rawBc5);
                            el.totalBc6 = getGreekCurrencyFormat(rawBc6);
                            el.totalBc7 = getGreekCurrencyFormat(rawBc7);
                        });
                    } else if (tableName === "Unregulated Debts Search") {
                        data.forEach((el) => {
                            el.initialAmount = getGreekCurrencyFormat(Number(el.initialAmount ?? 0));
                            el.totalPaidAmount = getGreekCurrencyFormat(Number(el.totalPaidAmount ?? 0));
                            el.nonOverdueAmount = getGreekCurrencyFormat(Number(el.nonOverdueAmount ?? 0));
                            el.overdueAmount = getGreekCurrencyFormat(Number(el.overdueAmount ?? 0));
                            el.surcharges = getGreekCurrencyFormat(Number(el.surcharges ?? 0));
                            el.totalAmount = getGreekCurrencyFormat(Number(el.totalAmount ?? 0));
                        });
                    }
                    // Calculate totals
                    const sumData = {}
                    tableColumns.forEach(column => {
                        if (column.inputType.type === "accounting") {
                            let sum = 0;
                            data.forEach(el => {
                                if (!isEmpty(el[column.field]) && !isNaN(el[column.field])) {
                                    sum += Number(el[column.field]);
                                    el[column.field] = Number(el[column.field]).toFixed(2);
                                }
                            });
                            sumData[column.field] = sum.toFixed(2);
                        } else {
                            sumData[column.field] = "";
                        }
                    });
                    data.push(sumData);

                    if (exportType === "excel") {
                        const workbook = XLSX.utils.book_new();
                        const excelData = [];
                        for (let d of data) {
                            let prepObj = {};
                            for (let col of tableColumns) {
                                prepObj[col.field] = d[col.field];
                            }
                            excelData.push(prepObj);
                        }

                        let worksheet = XLSX.utils.json_to_sheet(excelData, {origin: "A8"});
                        XLSX.utils.sheet_add_aoa(worksheet,
                            [['Επωνυμία:', this.companyDetails?.name],
                                ['Διακ. Τίτλος:', this.companyDetails?.smallName],
                                ['ΑΦΜ:', this.companyDetails?.vatNumber],
                                ['Δραστηριότητα:', this.companyDetails?.activity],
                                ['ΓΕΜΗ:', this.companyDetails?.gemhNo],
                                ['Τηλέφωνο:', this.companyDetails?.phone]],
                            {origin: "A1"}
                        );
                        // Make headers bold
                        for (let col = 0; col < Object.keys(excelData[0]).length; col++) {
                            const cellAddress = XLSX.utils.encode_cell({r: 7, c: col});
                            if (worksheet[cellAddress]) {
                                worksheet[cellAddress].s = {
                                    font: {bold: true}
                                };
                            }
                        }

                        const columnNames = Object.keys(excelData[0]).map((key) => tableColumns.find((el) => el.field === key)?.name);

                        XLSX.utils.sheet_add_aoa(worksheet, [columnNames], {origin: "A8"});
                        XLSX.utils.book_append_sheet(workbook, worksheet, "Πωλήσεις");
                        XLSX.writeFile(workbook, exportFileName + ".xlsx");
                    } else if (exportType === "pdf") {
                        const doc = new jsPDF('landscape');

                        doc.addFileToVFS("arialuni.ttf", liberationSerif);
                        doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                        doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                        doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                        doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                        doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
                        doc.setFont("DejaVu Sans Bold");
                        doc.setFontSize(17);
                        const header = doc.splitTextToSize(this.props.exportFileName, 200);
                        const headerString = header.join("\n"); // Join the array elements into a single string with line breaks
                        doc.text(headerString, doc.internal.pageSize.getWidth() / 2.5, 9, {alignment: "center"});
                        doc.setFont("DejaVu Sans Normal");
                        doc.setFontSize(11);
                        doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY HH:mm:ss")}`, 15, 18, {alignment: "center"});
                        const imgData = 'assets/images/prrimer-logo.png';
                        const imgX = doc.internal.pageSize.getWidth() - 45; // adjust the position as needed
                        const imgY = 3; // adjust the position as needed
                        doc.addImage(imgData, 'PNG', imgX, imgY, 40, 15);
                        doc.setFont("DejaVu Sans Normal");
                        const columns = tableColumns.map(el => {
                            return el.name;
                        });
                        const rows = data.map(row => {
                            return tableColumns.map(col => {
                                return row[col.field] ?? "";
                            });
                        });
                        const columnStyles = {};
                        const pageWidth = doc.internal.pageSize.getWidth();
                        tableColumns.forEach((column, idx) => {
                            if (isNaN(Number(column.width?.replace("%", "")))) {
                                columnStyles[idx] = {cellWidth: 'auto'};
                            } else {
                                columnStyles[idx] = {cellWidth: (pageWidth * Number(column.width?.replace("%", "") / 100))};
                            }
                        });

                        autoTable(doc, {
                            startY: 20,
                            head: [columns],
                            body: rows,
                            theme: "striped",
                            rowPageBreak: "avoid",
                            columnStyles: columnStyles,
                            styles: {
                                font: "DejaVu Sans Normal",
                                fontStyle: "normal",
                                fontSize: 10,
                                halign: "center",
                                overflow: 'linebreak'
                            },
                            didParseCell: (data) => {
                                // Check if the current row is a header row
                                if (data.row.raw === columns || data.row.index === rows.length - 1) {
                                    data.cell.styles.fillColor = [241, 253, 255]; // set fill color for the header row
                                    data.cell.styles.textColor = [0, 0, 0]; // set text color for the header row
                                    data.cell.styles.font = "DejaVu Sans Bold";
                                } else {
                                    data.cell.styles.textColor = [0, 0, 0]; // set text color for the header row
                                }
                            }
                        });

                        doc.save(`${this.props.exportFileName}.pdf`);

                        const pageCount = doc.getNumberOfPages();
                        for (let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            doc.setFontSize(10);
                            doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                        }
                    }
                } else {
                    toast.error("Service is unavailable for the moment. Please try again later.");
                }
            } else {
                toast.error(res.data.Error ?? res.data.message);
            }
            this.setState({searchExportLoader: false});
        }).catch((err) => {
            if (err) {
                console.log(err)
                toast.error("Service is unavailable for the moment. Please try again later.");
            }
            this.setState({searchExportLoader: false});
        })
    }

    handleExportToExcelReport = async () => {
        this.setState({
            loader: true,
        });
        const tableColumns = this.state.tableColumns;
        const tableName = this.state.tableName;
        let requestData = {
            company: this.props.company.id,
            year: this.props.company.year.toString(),
            columns: tableColumns,
            tableName: tableName,
        };
        if (this.props.tableName === "Sales Balance Sheet") {
            requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                date_from: this.props.filters?.date_from,
                date_to: this.props.filters?.date_to,
                clientName: this.props.filters?.clientName,
                invoiceType: this.props.filters?.invoiceType.map(el => el.value),
                paymentType: this.props.filters?.paymentType.map(el => el.value),
                automaticSales: this.props.filters?.automaticSales,
                providerChannel: this.props.filters?.providerChannel.map(el => el.value),
                carNumber: this.props.filters?.carNumber.map(el => el.value),
                numberFrom: this.props.filters?.numberFrom,
                numberTo: this.props.filters?.numberTo,
                productName: this.props.filters?.productName,
                totalSum_from: this.props.filters?.totalSum_from,
                totalSum_to: this.props.filters?.totalSum_to,
                preNumber_from: this.props.filters?.preNumber_from,
                preNumber_to: this.props.filters?.preNumber_to,
                myDataStatus: this.props.filters?.myDataStatus.map(el => el.value),
                paymentStatus: this.props.filters?.paymentStatus.map(el => el.value),
                notes: this.props.filters?.notes,
            };
        } else if (this.props.tableName === "Buys Monthly Turnover") {
            requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                date_from: this.props.filters?.date_from,
                date_to: this.props.filters?.date_to,
                clientName: this.props.filters?.clientName,
            };
        } else if (this.props.tableName === "Sales Monthly Turnover") {
            requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                date_from: this.props.filters?.date_from,
                date_to: this.props.filters?.date_to,
                clientName: this.props.filters?.clientName,
            };
        } else if (this.props.tableName === "Emron Payments Report") {
            requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                month: this.props.filters?.month ? this.props.filters?.month : "",
                clientName: this.props.filters?.clientName ? this.props.filters?.clientName : "",
                groupInstallations: this.props.filters.groupInstallations,
                groupClients: this.props.filters.groupClients,
                cardPayments: this.props.filters.cardPayments,
                showZero: this.props.filters.showZero,
                page: -1
            };
        } else if (this.props.tableName === "Buys Balance Sheet") {
            requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                month: this.props.filters?.month ? this.props.filters?.month : "",
                date_from: this.props.filters?.date_from,
                date_to: this.props.filters?.date_to,
                supplierName: this.props.filters?.supplierName_from,
                invoiceType: this.props.filters?.invoiceType.map(el => el.value),
                paymentType: this.props.filters?.paymentType.map(el => el.value),
                carNumber: this.props.filters?.carNumber.map(el => el.value),
                numberFrom: this.props.filters?.numberFrom,
                numberTo: this.props.filters?.numberTo,
                preNumberFrom: this.props.filters?.preNumberFrom,
                preNumberTo: this.props.filters?.preNumberTo,
                amountFrom: this.props.filters?.amountFrom,
                amountTo: this.props.filters?.amountTo,
                notes: this.props.filters?.notes,
            };
        } else if (this.props.tableName === "Client Payments Report") {
            requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                month: this.props.filters?.month ? this.props.filters?.month : "",
                date_from: this.props.filters?.date_from ? this.props.filters?.date_from : "",
                date_to: this.props.filters?.date_to ? this.props.filters?.date_to : "",
                clientName_from: this.props.filters?.clientName_from ? this.props.filters?.clientName_from : "",
                clientName_to: this.props.filters?.clientName_to ? this.props.filters?.clientName_to : "",
                invoiceType: this.props.filters?.invoiceType ? this.props.filters?.invoiceType.map(el => el.value) : [],
                paymentType: this.props.filters?.paymentType ? this.props.filters?.paymentType.map(el => el.value) : [],
                numberFrom: this.props.filters.numberFrom ?? "",
                numberTo: this.props.filters.numberTo ?? "",
                amountFrom: this.props.filters.amountFrom ?? "",
                amountTo: this.props.filters.amountTo ?? "",
                notes: this.props.filters.notes ?? "",
            };
        } else if (this.props.tableName === "Supplier Payments Report") {
            requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                date_from: this.props.filters?.date_from ? this.props.filters?.date_from : "",
                date_to: this.props.filters?.date_to ? this.props.filters?.date_to : "",
                supplierName: this.props.filters?.supplierName ? this.props.filters?.supplierName : "",
                invoiceType: this.props.filters?.invoiceType ? this.props.filters?.invoiceType.map(el => el.value) : [],
                paymentType: this.props.filters?.paymentType ? this.props.filters?.paymentType.map(el => el.value) : [],
                numberFrom: this.props.filters?.numberFrom ?? "",
                numberTo: this.props.filters?.numberTo ?? "",
                amountFrom: this.props.filters?.amountFrom ?? "",
                amountTo: this.props.filters?.amountTo ?? "",
            }
        } else if (this.props.tableName === "Product Balance Report") {
            requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                date_to: this.props.filters?.date_to ? this.props.filters?.date_to : "",
                product_inactive: this.props.filters.product_inactive,
                product_zero: this.props.filters.product_zero,
                installation: this.props.filters?.installation ? this.props.filters.installation.map(el => el.value) : [],
                productName: this.props.filters?.productName,
            };
        } else if (this.props.tableName === "Supplier Balance Report") {
            requestData = {
                columns: tableColumns,
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                tableName: "Supplier Balance Report",
                ...this.props.filters,
                page: -1,
            }
        } else if (this.props.tableName === "Client Balance Report") {
            requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                date_to: this.props.filters?.date_to ? this.props.filters?.date_to : "",
                clientName: this.props.filters?.clientName ? this.props.filters?.clientName : "",
                showZeroBalance: this.props.filters?.showZeroBalance,
                showInActive: this.props.filters?.showInActive,
                includeSettlements: this.props.filters?.includeSettlements,
            };
        } else if (this.props.tableName === "Client Isozygio Report") {
            requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                date_from: this.props.filters?.date_from ? this.props.filters?.date_from : "",
                date_to: this.props.filters?.date_to ? this.props.filters?.date_to : "",
                clientName: this.props.filters?.clientName ? this.props.filters?.clientName : "",
                zeroBalanceClients: this.props.filters?.zeroBalanceClients,
                page: -1
            };
        } else if (this.props.tableName === "Supplier Isozygio Report") {
            requestData = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: tableName,
                date_from: this.props.filters?.date_from ? this.props.filters?.date_from : "",
                date_to: this.props.filters?.date_to ? this.props.filters?.date_to : "",
                supplierName: this.props.filters?.clientName ? this.props.filters?.supplierName : "",
                zeroBalanceSuppliers: this.props.filters?.zeroBalanceSuppliers,
                page: -1
            };
        } else if (this.props.tableName === "Client Subscriptions Report") {
            requestData = {
                tableName: tableName,
                columns: tableColumns,
                company: this.props.company.id,
                user: JSON.parse(localStorage.getItem("user"))._id,
                filterClientName: this.props.filters?.filterClientName,
                filterSubscriptionNames: this.props.filters?.filterSubscriptionNames,
                startDateFrom: this.props.filters?.startDateFrom,
                startDateTo: this.props.filters?.startDateTo,
                activationDateFrom: this.props.filters?.activationDateFrom,
                activationDateTo: this.props.filters?.activationDateTo,
                status: this.props.filters?.status,
                page: -1,
            }
        } else if (this.props.tableName === "MyData Report" || this.props.tableName === "MyData Report Buys") {
            requestData = {
                company: this.props.company.id,
                date_from: moment().startOf("month").format("DD/MM/YYYY"),
                date_to: moment().endOf("month").format("DD/MM/YYYY"),
                number_from: this.props.filters?.number_from ?? "",
                number_to: this.props.filters?.number_to ?? "",
                invoiceType: this.props.filters?.invoiceType ?? [],
                showFilter: this.props.filters?.showFilter ?? "all",
                invoicesFromChannel: this.props.filters?.invoicesFromChannel ?? "all",
                totalSum_from: this.props.filters?.totalSum_from ?? "",
                totalSum_to: this.props.filters?.totalSum_to ?? "",
                showAccounting: this.props.filters?.showAccounting ?? true,
                lastUpdate: this.props.filters?.lastUpdate ?? "",
                forExport: true
            };
            if (this.props.tableName === "MyData Report") {
                requestData["clientVAT"] = this.props.filters?.clientVAT ?? "";
                requestData["showClients"] = this.props.filters?.showClients ?? "";
                requestData["reportType"] = "sales";
            } else if (this.props.tableName === "MyData Report Buys") {
                requestData["supplierVAT"] = this.props.filters?.supplierVAT ?? "";
                requestData["showSuppliers"] = this.props.filters?.showSuppliers ?? "";
                requestData["reportType"] = "buys";
            }
            const res = await axios.post(process.env.REACT_APP_API_URL2 + `/report/fetch-mydata-report`, requestData, {headers: {"Content-Type": "application/json"}});
            let dR = [];
            if (res.data.data.length > 0) {
                const totals = res.data.totals;
                res.data.data.forEach((element) => {
                    const date = element.date?.split("T")[0];
                    const classified = isEmpty(element.classified) || element.classified === "false" ? "Όχι" : element?.hasDifference ? "Ναι, με διαφορά" : "Ναι";
                    if (element.myDataStatus === "sent") element.myDataStatus = "Απεσταλμένο";
                    else if (element.myDataStatus === "not_sent") element.myDataStatus = "Μη Απεσταλμένο";
                    else if (element.myDataStatus === "aade_offline") element.myDataStatus = "Μη Απεσταλμένο (ΑΑΔΕ Εκτός Σύνδεσης)"
                    if (element.myDataSentStatus === "sent") element.myDataSentStatus = "Απεσταλμένο";
                    else if (element.myDataSentStatus === "not_sent") element.myDataSentStatus = "Μη Απεσταλμένο";
                    else if (element.myDataSentStatus === "aade_offline") element.myDataSentStatus = "Μη Απεσταλμένο (ΑΑΔΕ Εκτός Σύνδεσης)";

                    if (["5.1", "5.2", "11.4", "13.31", "14.31"].includes(element.myDataType) || (String(element.myDataType).startsWith("17.") && element?.classifications?.some((el) => el.recType === "7"))) {
                        element.totalNetValue = `-${element.totalNetValue}`;
                        element.totalVatValue = `-${element.totalVatValue}`;
                        element.totalAmount = `-${element.totalAmount}`;
                    }

                    let obj = {
                        "Ημερομηνία": date,
                        "MARK": element.mark,
                        "Πελάτης": this.props.tableName === "sales" ? element.clientName : element.supplierName,
                        "ΑΦΜ Πελάτη": element.vat,
                        "Τύπος Παραστατικού": element.myDataType,
                        "Αρίθμηση": element.number,
                        "Καθαρή Αξία": element.totalNetValue,
                        "Ποσό Φ.Π.Α.": element.totalVatValue,
                        "Συνολική Αξία": element.totalAmount,
                        "Κατάσταση ERP": element.myDataStatus,
                        "Κατάσταση MyData": element.myDataSentStatus,
                        "Χαρ.": classified
                    };
                    dR.push(obj);
                });
                console.log(totals)
            }
            this.setState({loader: false});
            const worksheet = XLSX.utils.json_to_sheet(dR);
            toast.success(res.data.message);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            XLSX.writeFile(workbook, this.props.tableName === "MyData Report" ? "MyData Sales Report.xlsx" : "MyData Buys Report.xlsx");
            return;
        } else if (this.props.tableName === "Companies AI usage report") {
            const excelRequest = {
                company: this.props.company.id,
                year: this.props.company.year.toString(),
                columns: tableColumns,
                tableName: this.props.tableName,
                date_from: this.props.filters?.date_from || "",
                date_to: this.props.filters?.date_to || "",
                companies: this.props.filters?.companies || [],
                geminiCostFrom: this.props.filters?.geminiCostFrom || "",
                geminiCostTo: this.props.filters?.geminiCostTo || "",
                primerCostFrom: this.props.filters?.primerCostFrom || "",
                primerCostTo: this.props.filters?.primerCostTo || "",
                creditConversion: this.props.filters?.creditConversion || "",
                page: -1,
            };

            try {
                const res = await axios.post(`${process.env.REACT_APP_API_URL2}/ai/companies-ai-usage-report`, excelRequest, {
                    headers: {"Content-Type": "application/json"}
                });

                if (res.data && res.status === 200) {
                    const results = res.data.data || [];
                    let dR = [];

                    const columnNames = ["Εταιρεία", "ΑΦΜ", "ΑΙ Credits Files", "AI Credits myDATA", "AI Credits", "Αρ. Αρχείων", "Αρ. παρ. myDATA", "Σύνολο παραστατικών", "Κόστος Gemini", "Κόστος Primer"];
                    dR.push(columnNames);

                    let totalGemini = 0;
                    let totalTokens = 0;
                    let totalPrimer = 0;
                    let totalAiTokenFiles = 0;
                    let totalAiTokenMyData = 0;
                    let totalFilesCount = 0;
                    let totalMyDataCount = 0;
                    let totalDocumentCount = 0;

                    if (results.length > 0) {
                        dR = [...dR, ...results.map((item) => {
                            totalAiTokenFiles += +item.aiTokensFiles || 0;
                            totalAiTokenMyData += +item.aiTokensMyData || 0;
                            totalTokens += +item.aiTokens || 0;
                            totalFilesCount += +item.filesCount || 0;
                            totalMyDataCount += +item.myDataCount || 0;
                            totalDocumentCount += +item.totalDocumentCount || 0;
                            totalGemini += +item.geminiCost || 0;
                            totalPrimer += +item.primerCost || 0;

                            return [
                                item.companyName,
                                item.companyVatNumber,
                                item.aiTokensFiles,
                                item.aiTokensMyData,
                                item.aiTokens,
                                item.filesCount,
                                item.myDataCount,
                                item.totalDocumentCount,
                                item.geminiCost,
                                item.primerCost
                            ];
                        })];

                        dR.push([
                            "ΣΥΝΟΛΑ", "",
                            totalAiTokenFiles,
                            totalAiTokenMyData,
                            totalTokens,
                            totalFilesCount,
                            totalMyDataCount,
                            totalDocumentCount,
                            +Number(totalGemini).toFixed(2),
                            +Number(totalPrimer).toFixed(2),
                        ]);
                    }

                    this.setState({ loader: false });

                    const worksheet = XLSX.utils.aoa_to_sheet(dR);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "AI Usage");
                    XLSX.writeFile(workbook, "Στατιστικά Χρήσης ΑΙ.xlsx");
                    toast.success("Το αρχείο Excel λήφθηκε επιτυχώς.");
                    return;
                }
            } catch (err) {
                console.error("Excel Generation Error:", err);
                this.setState({ loader: false });
                toast.error("Σφάλμα κατά τη δημιουργία του Excel.");
                return;
            }
        }
        await axios.post(process.env.REACT_APP_API_URL2 + `/report/export-report`, requestData, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            if (res.data.status === "200" || res.data.status === "422") {
                if (this.props.tableName === "Sales Balance Sheet") {
                    let dR = [];
                    if (res.data.data.length > 0) {
                        res.data.data.forEach((element) => {
                            let obj = {
                                "Ημερομηνία": moment(element?.date).format("DD/MM/YYYY HH:mm"),
                                "Τύπος Παραστατικού": element?.documentTypeName,
                                "Αρίθμηση": element?.preNumber.replace("noprefix", "") + " " + element?.number,
                                "Κωδικός Πελάτη": element?.clientCode,
                                "Όνομα Πελάτη": element?.clientName,
                                "ΑΦΜ Πελάτη": element?.vat,
                                "Τηλέφωνο Πελάτη": element?.phone,
                                "Τρόπος Πληρωμής": element?.paymentTypeName,
                                "Καθαρή Αξία": Number(Number(element?.totalNetValue).toFixed(2)),
                                "ΦΠΑ 24%": Number(Number(element?.vat24).toFixed(2)),
                                "ΦΠΑ 13%": Number(Number(element?.vat13).toFixed(2)),
                                "ΦΠΑ 6%": Number(Number(element?.vat6).toFixed(2)),
                                "ΦΠΑ 17%": Number(Number(element?.vat17).toFixed(2)),
                                "ΦΠΑ 9%": Number(Number(element?.vat9).toFixed(2)),
                                "ΦΠΑ 4%": Number(Number(element?.vat4).toFixed(2)),
                                "Αξία ΦΠΑ": Number(Number(element?.totalVatValue).toFixed(2)),
                                "Συνολική Αξία": Number(Number(element?.totalAmount).toFixed(2)),
                                "Πληρωτέο Ποσό": Number(Number(element?.paymentAmount).toFixed(2)),
                                "Περιέχοντα είδη": element?.productNamesBalanceSheet,
                                "Σημειώσεις": element?.notes,
                                "MARK": element?.mark,
                                "Χώρα Πελάτη": element?.country,
                            };
                            dR.push(obj);
                        });
                    }
                    this.setState({loader: false});
                    const worksheet = XLSX.utils.json_to_sheet(dR);
                    toast.success(res.data.message);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                    XLSX.writeFile(workbook, "Sales Balance Sheet.xlsx");
                } else if (this.props.tableName === "Sales Monthly Turnover" || this.props.tableName === "Buys Monthly Turnover") {
                    let dR = [];
                    let generalTotal = 0;
                    if (res.data.data.length > 0) {
                        res.data.data.forEach((element) => {
                            generalTotal += this.props.tableName === "Sales Monthly Turnover" ? element.cTotal : element.sTotal;
                            let obj = {
                                [this.props.tableName === "Sales Monthly Turnover" ? "Πελάτης" : "Προμηθευτής"]: this.props.tableName === "Sales Monthly Turnover" ? element.clientName : element.supplierName,
                                "Ιανουάριος": element.jan,
                                "Φεβρουάριος": element.feb,
                                "Μάρτιος": element.mar,
                                "Απρίλιος": element.apr,
                                "Μάιος": element.may,
                                "Ιούνιος": element.jun,
                                "Ιούλιος": element.jul,
                                "Αύγουστος": element.aug,
                                "Σεπτέμβριος": element.sep,
                                "Οκτώβριος": element.oct,
                                "Νοέμβριος": element.nov,
                                "Δεκέμβριος": element.dec,
                                [this.props.tableName === "Sales Monthly Turnover" ? "Σύνολο Πελάτη" : "Σύνολο Προμηθευτή"]: this.props.tableName === "Sales Monthly Turnover" ? element.cTotal : element.sTotal,
                            };
                            dR.push(obj);
                        });
                    }
                    dR.push({
                        "Πελάτης": "",
                        "Ιανουάριος": "",
                        "Φεβρουάριος": "",
                        "Μάρτιος": "",
                        "Απρίλιος": "",
                        "Μάιος": "",
                        "Ιούνιος": "",
                        "Ιούλιος": "",
                        "Αύγουστος": "",
                        "Σεπτέμβριος": "",
                        "Οκτώβριος": "",
                        "Νοέμβριος": "",
                        "Δεκέμβριος": "",
                        [this.props.tableName === "Sales Monthly Turnover" ? "Σύνολο Πελάτη" : "Σύνολο Προμηθευτή"]: generalTotal
                    });
                    this.setState({loader: false});
                    const worksheet = XLSX.utils.json_to_sheet(dR);
                    toast.success(res.data.message);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                    XLSX.writeFile(workbook, this.props.tableName === "Sales Monthly Turnover" ? "Τζίρος Πωλήσεων Ανα Περίοδο.xlsx" : "Τζίρος Αγορών Ανα Περίοδο.xlsx");
                } else if (this.props.tableName === "Emron Payments Report") {
                    let columnNames = [];
                    let columnFields = [];
                    for (let tb of tableColumns) {
                        columnNames.push(tb.name);
                        columnFields.push(tb.field);
                    }
                    let rows = [];
                    rows.push(columnNames);
                    if (res.data.data.length > 0) {
                        for (let movement of res.data.data) {
                            let resRow = [];
                            for (let col of columnFields) {
                                if (!isEmpty(movement[col])) {
                                    resRow.push(movement[col]);
                                } else {
                                    resRow.push("");
                                }
                            }
                            rows.push(resRow);
                        }
                    }
                    this.setState({loader: false});
                    const worksheet = XLSX.utils.aoa_to_sheet(rows);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                    XLSX.writeFile(workbook, "Μηνιαίες χρεώσεις.xlsx");
                } else if (this.props.tableName === "Buys Balance Sheet") {
                    let dR = [];
                    if (res.data.data.length > 0) {
                        res.data.data.forEach((element) => {
                            let obj = {
                                "Ημερομηνία": moment(element?.date).format("DD/MM/YYYY HH:mm"),
                                "Τύπος Παραστατικού": element?.documentTypeName,
                                "Αρίθμηση": element?.preNumber.replace("noprefix", "") + " " + element?.number,
                                "Κωδικός Προμηθευτή": element?.supplierCode,
                                "Όνομα Προμηθευτή": element?.supplierName,
                                "ΑΦΜ Προμηθευτή": element?.vat,
                                "Τρόπος Πληρωμής": element?.paymentTypeName,
                                "Εκπιπτόμενη Καθαρή Αξία": Number(Number(element?.totalDeductibleNetValue).toFixed(2)),
                                "Μη Εκπιπτόμενη Καθαρή Αξία": Number(Number(element?.totalNonDeductibleNetValue).toFixed(2)),
                                "Αξία Εκπιπτόμενου Φ.Π.Α.": Number(Number(element?.totalDeductibleVAT).toFixed(2)),
                                "Αξία Μη Εκπιπτόμενου Φ.Π.Α.": Number(Number(element?.totalNonDeductibleVAT).toFixed(2)),
                                "Αναμόρφωση Καθαρής Αξίας": Number(Number(element?.totalAnamorfosisNet).toFixed(2)),
                                "Αναμόρφωση ΦΠΑ": Number(Number(element?.totalAnamorfosisVat).toFixed(2)),
                                "Συνολική Αξία": Number(Number(element?.totalAmount).toFixed(2))
                            }
                            dR.push(obj);
                        })
                    }
                    this.setState({loader: false});
                    const worksheet = XLSX.utils.json_to_sheet(dR);
                    toast.success(res.data.message);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                    XLSX.writeFile(workbook, "Buys Balance Sheet.xlsx");
                } else if (this.props.tableName === "Client Payments Report") {
                    let dR = [];
                    if (res.data.data.length > 0) {
                        res.data.data.forEach((element) => {
                            let obj = {
                                "Ημερομηνία": moment(element?.date).format("DD/MM/YYYY"),
                                "Όνομα Πελάτη": element.clientName,
                                "ΑΦΜ Πελάτη": element.vatNumber,
                                "Τύπος Παραστατικού": element.documentTypeName,
                                "Αρίθμηση": element.preNumber === "noprefix" ? element.number : element.preNumber + " " + element.number,
                                "Ποσό": Number(Number(element.amount).toFixed(2)),
                                "Τρόπος Πληρωμής": element.paymentTypeName,
                            }
                            dR.push(obj);
                        })
                    }
                    this.setState({loader: false});
                    const worksheet = XLSX.utils.json_to_sheet(dR);
                    toast.success(res.data.message);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                    XLSX.writeFile(workbook, "Client Payments Report.xlsx");
                } else if (this.props.tableName === "Supplier Payments Report") {
                    let dR = [];
                    if (res.data.data.length > 0) {
                        res.data.data.forEach((element) => {
                            let obj = {
                                "Ημερομηνία": moment(element?.date).format("DD/MM/YYYY"),
                                "Όνομα Προμηθευτή": element.supplierName,
                                "ΑΦΜ Προμηθευτή": element.vatNumber,
                                "Τύπος Παραστατικού": element.documentTypeName,
                                "Αρίθμηση": element.preNumber === "noprefix" ? element.number : element.preNumber + " " + element.number,
                                "Ποσό": Number(Number(element.amount).toFixed(2)),
                                "Τρόπος Πληρωμής": element.paymentTypeName,
                            }
                            dR.push(obj);
                        })
                    }
                    this.setState({loader: false});
                    const worksheet = XLSX.utils.json_to_sheet(dR);
                    toast.success(res.data.message);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                    XLSX.writeFile(workbook, "Supplier Payments Report.xlsx");
                } else if (this.props.tableName === "Product Balance Report") {
                    let dR = [];
                    if (res.data.data.length > 0) {
                        res.data.data.forEach((element) => {
                            let obj = {
                                "Κωδικός Προιόντος": element.code,
                                "Εναλλακτικός Κωδικός": element.alternateCode,
                                "Όνομα Προιόντος": element._id.productName,
                                "Απόθεμα": element.inventory,
                                "Υπόλοιπο": Number(Number(element.balance).toFixed(2)),
                                "Κόστος Αποθήκης": Number(Number(element.warehouseCost).toFixed(2)),
                            }
                            dR.push(obj);
                        })
                    }
                    this.setState({loader: false});
                    const worksheet = XLSX.utils.json_to_sheet(dR);
                    toast.success(res.data.message);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                    XLSX.writeFile(workbook, "Product Balance Report.xlsx");
                } else if (this.props.tableName === "Client Balance Report") {
                    let dR = [];
                    if (res.data.data.length > 0) {
                        if (res.data.includeSettlements === "active") {
                            res.data.data.forEach((element) => {
                                let obj = {
                                    "Απογραφή": Number(Number(element.census).toFixed(2)),
                                    "Όνομα Πελάτη": element.clientName,
                                    "Α.Φ.Μ. Πελάτη": element.vatNumber,
                                    "Υπόλοιπο": Number(Number(element.balance).toFixed(2)),
                                    "Διακανονισμένο Υπόλοιπο": Number(Number(element.totalSettledAmount).toFixed(2)),
                                    "Υπόλοιπο μετά διακανονισμών": Number(Number(element.balanceWithSettledAmount).toFixed(2)),
                                }
                                dR.push(obj);
                            })
                        } else {
                            res.data.data.forEach((element) => {
                                let obj = {
                                    "Απογραφή": Number(Number(element.census).toFixed(2)),
                                    "Όνομα Πελάτη": element.clientName,
                                    "Α.Φ.Μ. Πελάτη": element.vatNumber,
                                    "Υπόλοιπο": Number(Number(element.balance).toFixed(2)),
                                }
                                dR.push(obj);
                            })
                        }
                    }
                    this.setState({loader: false});
                    const worksheet = XLSX.utils.json_to_sheet(dR);
                    toast.success(res.data.message);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                    XLSX.writeFile(workbook, "Client Balance Report.xlsx");
                } else if (this.props.tableName === "Client Isozygio Report") {
                    let dR = [];
                    if (res.data.data.length > 0) {
                        res.data.data.forEach((element) => {
                            let obj = {
                                "Από Μεταφορά": element.carryOverBalance,
                                "Κωδικός Πελάτη": element.code,
                                "Όνομα Πελάτη": element.name,
                                "Α.Φ.Μ. Πελάτη": element.vatNumber,
                                "Χρέωση": element.debit,
                                "Πίστωση": element.credit,
                                "Υπόλοιπο Περιόδου": element.balance,
                                "Συνολικό Υπόλοιπο": element.totalBalance,
                            }
                            dR.push(obj);
                        })
                    }
                    this.setState({loader: false});
                    const worksheet = XLSX.utils.json_to_sheet(dR);
                    toast.success(res.data.message);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                    XLSX.writeFile(workbook, "Client Isozygio Report.xlsx");
                } else if (this.props.tableName === "Supplier Isozygio Report") {
                    let dR = [];
                    if (res.data.data.length > 0) {
                        res.data.data.forEach((element) => {
                            let obj = {
                                "Από Μεταφορά": element.carryOverBalance,
                                "Κωδικός Προμηθευτή": element.code,
                                "Όνομα Προμηθευτή": element.name,
                                "Α.Φ.Μ. Προμηθευτή": element.vatNumber,
                                "Χρέωση": element.debit,
                                "Πίστωση": element.credit,
                                "Υπόλοιπο Περιόδου": element.balance,
                                "Συνολικό Υπόλοιπο": element.totalBalance,
                            }
                            dR.push(obj);
                        })
                    }
                    this.setState({loader: false});
                    const worksheet = XLSX.utils.json_to_sheet(dR);
                    toast.success(res.data.message);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                    XLSX.writeFile(workbook, "Supplier Isozygio Report.xlsx");
                } else if (this.props.tableName === "Supplier Balance Report") {
                    let dR = [];
                    if (res.data.data.length > 0) {
                        res.data.data.forEach((element) => {
                            let obj = {
                                "Απογραφή": Number(Number(element.census).toFixed(2)),
                                "Όνομα Προμηθευτή": element.supplierName,
                                "Α.Φ.Μ. Προμηθευτή": element.vatNumber,
                                "Υπόλοιπο": Number(Number(element.balance).toFixed(2)),
                                "IBANs": element.bankInfo?.length > 0 ? element?.bankInfo.map((o) => `${o.bankFriendlyName} : ${o.iban}`).join(" , ") : "",
                            }
                            dR.push(obj);
                        });
                    }
                    this.setState({loader: false});
                    const worksheet = XLSX.utils.json_to_sheet(dR);
                    toast.success(res.data.message);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                    XLSX.writeFile(workbook, "Supplier Balance Report.xlsx");
                } else if (this.props.tableName === "Client Subscriptions Report") {
                    let dR = [];
                    if (res.data.data.length > 0) {
                        res.data.data.forEach((element) => {
                            let obj = {
                                "Όνομα Πελάτη": element.clientName,
                                "Α.Φ.Μ. Πελάτη": element.clientVATNumber,
                                "Όνομα Συνδρομής": element.subscriptionName,
                                "Ημερομηνία Έναρξης": element.startDate,
                                "Ημερομηνία Ενεργοποίησης": element.activatedDate,
                                "Ημερομηνία Λήξης" : element.endDate,
                                "Κατάσταση" : element.status,
                                "Τιμή": element.price,
                            };
                            dR.push(obj);
                        });
                    }
                    dR.push({
                        "Όνομα Πελάτη": "",
                        "Α.Φ.Μ. Πελάτη": "",
                        "Όνομα Συνδρομής": "",
                        "Ημερομηνία Έναρξης": "",
                        "Ημερομηνία Ενεργοποίησης": "",
                        "Ημερομηνία Λήξης" : "",
                        "Κατάσταση" : "",
                        "Τιμή": "",
                    })
                    dR.push({
                        "Όνομα Πελάτη": "",
                        "Α.Φ.Μ. Πελάτη": "",
                        "Όνομα Συνδρομής": "",
                        "Ημερομηνία Έναρξης": "",
                        "Ημερομηνία Ενεργοποίησης": "",
                        "Ημερομηνία Λήξης" : "",
                        "Κατάσταση": "Συνολικό ποσό συνδρομών",
                        "Τιμή": this.props.totalSubscriptionSum ? this.props.totalSubscriptionSum.toLocaleString('de-DE', {minimumFractionDigits: 2, useGrouping: true, groupingSeparator: '.'}) : "0.00"
                    })
                    this.setState({loader: false});
                    const worksheet = XLSX.utils.json_to_sheet(dR);
                    toast.success(res.data.message);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                    XLSX.writeFile(workbook, "Client Subscriptions Report.xlsx");
                }
            }
        }).catch((err) => {
            if (err) {
                console.log(err)
                toast.error("Service is unavailable for the moment. Please try again later.");
            }
        })
    }

    getSelectedRow = {
        getRow: (data, rowIndex) => {
            this.props.onUpdate && this.props.onUpdate.selected(data, rowIndex);
        },
    }

    handleColumnShowHide = (field) => {
        let tempTc = this.state.tableColumns.slice();
        let object = getObjectFromArrayOfObjects(tempTc, field, "field");
        const index = tempTc.findIndex((item) => field === item.field);
        if (object.length > 0) {
            tempTc[index].hiddenColumn = !object["0"].hiddenColumn;
            this.setState({
                tableColumns: tempTc,
            });
        }
    };
    handleSaveToggleColumns = () => {
        if (
            this.props.tableName &&
            this.props.tableName !== "" &&
            this.state.tableColumns
        ) {
            const reqData = {
                userId: JSON.parse(localStorage.getItem("user"))._id,
                field: `tablesColumns.${this.props.tableName}`,
                value: this.state.tableColumns.filter((el) => !el.hiddenColumn && !["select_checkbox", "actions"].includes(el.field)).map((el) => el.field)
            };
            axios.post(process.env.REACT_APP_API_URL2 + `/user/user-settings`, reqData, {
                headers: { "Content-Type": "application/json" }
            }).then((res) => {
                if (res.data?.status === "200") {
                    this.props.handleUpdateUserSettings(res.data.data);
                    toast.success("Οι στήλες αποθηκεύτηκαν επιτυχώς.");
                }
            }).catch((e) => {
                console.log(e);
            });
        } else {
            toast.error("Table Name or Data not found.");
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.tableData !== this.state.tableData) {
            const { tableName, columns } = this.props;

            if (tableName === "Emron Payments Report") {
                const updatedTableColumns = getSavedHiddenColumns(tableName, columns, this.props.userSettings);
                this.setState({ tableColumns: updatedTableColumns });
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state !== nextState;
    }

    render() {
        const currentUser = getCurrentUser();
        const {tableData, filteredData, tableColumns} = this.state;
        // It will manage the new insert row with prop allowInsertRow value.
        let tableClasses = "table table-bordered mb-2 editable-table-ui";
        if (this.props.allowInsertRow || this.props.allowInsertRowFromTop) {
            tableClasses += " allow-insert-row";
        }

        if(this.props.onRowClick) {
            tableClasses += " simpleClassicTableGrayHoverWithClick";
        }

        let data = tableData;
        if (this.props.allowPagination) {
            data = filteredData;
        }
        let tableWrClasses = "table-responsive ";
        tableWrClasses = this.props.className
            ? tableWrClasses + this.props.className
            : tableWrClasses;

        const permissionsData = JSON.parse(localStorage.getItem("permissions"));

        return (
            <>
                <div className="table-pagination float-right no-print">
                    {this.props.allowPagination && data.length > 0 && (
                        <Pagination
                            currentPage={this.state.activePage}
                            totalPages={Math.ceil(this.state.count / this.state.rowsPerPage)}
                            handlePageChange={this.handlePageChange.bind(this)}
                            maxWidth={400}
                        />
                    )}
                </div>
                {this.props.showErrors && this.props.showErrorMessage !== "" && (
                    <div className="text-danger">{this.props.showErrorMessage}</div>
                )}
                <div className="no-print">
                    <div id="editableTableWr" ref={(el) => (this.editableTableRef = el)} className={tableWrClasses}>
                        {this.props.heading && (
                            <div className="text-muted mb-2">
                                <i>{this.props.heading}</i>
                            </div>
                        )}
                        <table style={{borderCollapse: "collapse", tableLayout: this.props?.fixedLayout ? 'fixed' : 'auto'}} id="editableTable" className={tableClasses}>
                            <TableHead
                                {...this.props}
                                toggleColumns={this.handleColumnShowHide}
                                saveToggleColumns={this.handleSaveToggleColumns}
                                headColumns={tableColumns}
                                handleChangeSortMethod={(!isEmpty(data) && this.props.handleChangeSortMethod) ? (e, field) => this.props.handleChangeSortMethod(e, field) : null}
                                tableName={this.props.tableName}
                                checkedRows={(this.props?.selectedRows && this.props?.selectedRowKey) ? this.props.selectedRows : this.state.checkedRows}
                                totalItems={this.props?.totalItems || 0}
                            />
                            <TableBody
                                {...this.props}
                                key={this.props.tableName}
                                requestData={this.state.pRequestData}
                                reqName={this.state.reqName}
                                insert={this.handleInsertNewRowToData}
                                update={this.handleUpdateRowToData}
                                editRedirectAllowed={this.props.editRedirectAllowed}
                                data={data}
                                columns={tableColumns}
                                switchCreditAndDebit={this.props.switchCreditAndDebit}
                                switchCreditAndDebitDisabled={this.props.switchCreditAndDebitDisabled}
                                emronPaymentsMonth={this.state.emronPaymentsMonth}
                                onRowSelect={this.getSelectedRow}
                                onRowClick={this.props.onRowClick}
                                checkedRows={(this.props?.selectedRows && this.props?.selectedRowKey) ? this.props.selectedRows : this.state.checkedRows}
                                selectedRowKey={this.props?.selectedRowKey || null}
                                permissionsData={permissionsData}
                            />
                            {this.props.enableFooter && (
                                <TableFooter
                                    data={data}
                                    footerData={this.props.footerData}
                                    columns={tableColumns}
                                    enableFooter={this.props.enableFooter}
                                />
                            )}
                        </table>
                        {this.props.pageTotals && (
                            <Row className="justify-content-end">
                                <Col sm="12" md="4" className="d-flex justify-content-end">
                                    <span className="mr-3 fw-bold" style={{width: "20%"}}>Σύνολα</span>
                                    <table className="table table-bordered mb-3" style={{width: "70%"}} id="editableTableTotal">
                                        <tbody>
                                        {this.props.totalNetValueTrue && (
                                            <tr>
                                                <td className="fw-bold">Συνολική Καθαρή Αξία</td>
                                                <td>{getGreekCurrencyFormat(this.props.totalNetValue.toFixed(2))}</td>
                                            </tr>
                                        )}
                                        {this.props.totalVatAmountTrue && (
                                            <tr>
                                                <td className="fw-bold">Συνολική Αξία ΦΠΑ</td>
                                                <td>{getGreekCurrencyFormat(this.props.totalVatAmount.toFixed(2))}</td>
                                            </tr>
                                        )}
                                        {this.props.totalDeductibleNetValueTrue && (
                                            <tr>
                                                <td className="fw-bold">Συνολική Εκπιπτόμενη Καθαρή Αξία</td>
                                                <td>{getGreekCurrencyFormat(this.props.totalDeductibleNetValue)}</td>
                                            </tr>
                                        )}
                                        {this.props.totalNonDeductibleNetValueTrue && (
                                            <tr>
                                                <td className="fw-bold">Συνολική Μη Εκπιπτόμενη Καθαρή Αξία</td>
                                                <td>{getGreekCurrencyFormat(this.props.totalNonDeductibleNetValue)}</td>
                                            </tr>
                                        )}
                                        {this.props.totalDeductibleVATTrue && (
                                            <tr>
                                                <td className="fw-bold">Συνολική Αξία Εκπιπτόμενου Φ.Π.Α.</td>
                                                <td>{getGreekCurrencyFormat(this.props.totalDeductibleVAT)}</td>
                                            </tr>
                                        )}
                                        {this.props.totalNonDeductibleVATTrue && (
                                            <tr>
                                                <td className="fw-bold">Συνολική Αξία Μη Εκπιπτόμενου Φ.Π.Α.</td>
                                                <td>{getGreekCurrencyFormat(this.props.totalNonDeductibleVAT)}</td>
                                            </tr>
                                        )}
                                        {this.props.totalValueTrue && (
                                            <tr>
                                                <td className="fw-bold">Συνολική Αξία</td>
                                                <td>{getGreekCurrencyFormat(this.props.totalValue)}</td>
                                            </tr>
                                        )}
                                        {this.props.totalPaymentAmountTrue && (
                                            <tr>
                                                <td className="fw-bold">Συνολικό Πληρωτέο Ποσό</td>
                                                <td>{getGreekCurrencyFormat(this.props.totalPaymentAmount)}</td>
                                            </tr>
                                        )}
                                        {this.props.inventoryAmountTrue && (
                                            <tr>
                                                <td className="fw-bold">Συνολικό Απόθεμα</td>
                                                <td>{this.props.inventoryAmount.toFixed(2)}</td>
                                            </tr>
                                        )}
                                        {(this.props.totalBalanceTrue && this.props.tableName === "Product Balance Report") ? (
                                            <tr>
                                                <td className="fw-bold">Συνολικό Υπόλοιπο</td>
                                                <td>{getGreekNumberFormat(this.props.totalBalance)}</td>
                                            </tr>
                                        ) : this.props.totalBalanceTrue ? (
                                            <tr>
                                                <td className="fw-bold">Συνολικό Υπόλοιπο</td>
                                                <td>{getGreekCurrencyFormat(this.props.totalBalance)}</td>
                                            </tr>
                                        ) : (
                                            <React.Fragment></React.Fragment>
                                        )}
                                        {(this.props.totalWarehouseCost !== undefined && this.props.tableName === "Product Balance Report") && (
                                            <tr>
                                                <td className="fw-bold">Συνολικό Κόστος Αποθήκης</td>
                                                <td>{getGreekCurrencyFormat(this.props.totalWarehouseCost)}</td>
                                            </tr>
                                        )}
                                        {this.props.showSubscriptionSum && (
                                            <tr>
                                                <td className="fw-bold">Συνολικό Ποσό Συνδρομών</td>
                                                {this.props.totalSubscriptionSum ? <td>{getGreekCurrencyFormat(this.props.totalSubscriptionSum)}</td> : <td>0.00</td>}
                                            </tr>
                                        )}
                                        {this.props.totalSettledAmountTrue && (
                                            <tr>
                                                <td className="fw-bold">Σύνολο διακανονισμένων ποσών</td>
                                                {this.props.totalSettledAmount ? <td>{getGreekCurrencyFormat(this.props.totalSettledAmount)}</td> : <td>0.00</td>}
                                            </tr>
                                        )}
                                        {this.props.totalBalanceWithSettledAmountTrue && (
                                            <tr>
                                                <td className="fw-bold">Συνολικό υπόλοιπο μετά διακανονισμών</td>
                                                {this.props.totalBalanceWithSettledAmount ? <td>{getGreekCurrencyFormat(this.props.totalBalanceWithSettledAmount)}</td> : <td>0.00</td>}
                                            </tr>
                                        )}
                                        {this.props.showIsozygioTotals && (
                                            <tr>
                                                <td className="fw-bold">Συνολικό Υπόλοιπο Από Μεταφορά</td>
                                                {this.props.totalCarryOverBalance ? <td>{getGreekCurrencyFormat(this.props.totalCarryOverBalance)}</td> : <td>0.00</td>}
                                            </tr>
                                        )}
                                        {this.props.showIsozygioTotals && (
                                            <tr>
                                                <td className="fw-bold">Σύνολο Χρεώσεων</td>
                                                {this.props.totalDebit ? <td>{getGreekCurrencyFormat(this.props.totalDebit)}</td> : <td>0.00</td>}
                                            </tr>
                                        )}
                                        {this.props.showIsozygioTotals && (
                                            <tr>
                                                <td className="fw-bold">Σύνολο Πιστώσεων</td>
                                                {this.props.totalCredit ? <td>{getGreekCurrencyFormat(this.props.totalCredit)}</td> : <td>0.00</td>}
                                            </tr>
                                        )}
                                        {this.props.showIsozygioTotals && (
                                            <tr>
                                                <td className="fw-bold">Συνολικό Υπόλοιπο Περιόδου</td>
                                                {this.props.totalPeriodBalance ? <td>{getGreekCurrencyFormat(this.props.totalPeriodBalance)}</td> : <td>0.00</td>}
                                            </tr>
                                        )}
                                        {this.props.showIsozygioTotals && (
                                            <tr>
                                                <td className="fw-bold">Συνολικό Γενικό Υπόλοιπο</td>
                                                {this.props.totalBalanceTotal ? <td>{getGreekCurrencyFormat(this.props.totalBalanceTotal)}</td> : <td>0.00</td>}
                                            </tr>
                                        )}
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                        )}
                    </div>
                </div>
                <div style={{display: "none"}} className="print-me" id="printReport">
                    <iframe onLoad={this.handleIframeLoad} ref={this.iframeRef} style={{ width: "100%" }} src={this.state.iframeData} title={"Print Report"}></iframe>
                </div>
                <div className="extra-features no-print">
                    {this.props.allowBulkActions && (
                        <div className="bulk-actions">
                            {this.props.allowPrintResults && (
                                <Dropdown className="mb-3">
                                    <Dropdown.Toggle disabled={this.state.loader || this.state.searchExportLoader} variant="primary" id="dropdown-basic">
                                        Εκτύπωση Αποτελεσμάτων
                                        {(this.state.loader || this.state.searchExportLoader) && (
                                            <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                                        )}
                                    </Dropdown.Toggle>
                                    {(!this.state.loader && !this.state.searchExportLoader) && (
                                        <Dropdown.Menu>
                                            {this.props.reportExcelPrint && (
                                                <Dropdown.Item onClick={() => this.handleExportToPdfReport(".pdf",null, true)}>
                                                    Εκτυπωτής
                                                </Dropdown.Item>
                                            )}
                                            {this.props.reportExcelPrint && (
                                                <Dropdown.Item onClick={() => this.handleExportToPdfReport()}>
                                                    Αποθήκευση ως PDF
                                                </Dropdown.Item>
                                            )}
                                            {!this.props.reportExcelPrint && (
                                                <Dropdown.Item onClick={() => this.handleExport('excel')}>
                                                    Αποθήκευση ως Excel
                                                </Dropdown.Item>
                                            )}
                                            {!this.props.reportExcelPrint && (
                                                <Dropdown.Item onClick={() => this.handleExport('pdf')}>
                                                    Αποθήκευση ως PDF
                                                </Dropdown.Item>
                                            )}
                                            {this.props.reportExcelPrint && (
                                                <Dropdown.Item onClick={() => this.handleExportToExcelReport()}>
                                                    Αποθήκευση ως Excel
                                                </Dropdown.Item>
                                            )}
                                        </Dropdown.Menu>
                                    )}
                                </Dropdown>
                            )}

                            <Modal className="themeModalBig" show={this.state.showResponseSentToMyData}>
                                <Modal.Header>
                                    <Modal.Title>{currentUser?.lang && currentUser.lang === "el" ? "Αποστολή Αναφοράς στο MyData" : "Send To MyData Report"}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>{currentUser?.lang && currentUser.lang === "el" ? "Παρακάτω εμφανίζονται τα αποτελέσματα για την αποστολή των επιλεγμένων Παραστατικών στο MyData:" : "Below are shown the results for the sending of the selected Documents to MyData:"}<br/> {this.state.responseSentToMyData}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="outline-primary" onClick={() => {
                                        this.setState((state) => {
                                            if (state.showResponseSentToMyData) {
                                                return {
                                                    showResponseSentToMyData: false,
                                                };
                                            }
                                        });
                                    }}>OK</Button>
                                </Modal.Footer>
                            </Modal>
                            <Modal className="themeModalBig" show={this.state.showResponseCancelToMyData}>
                                <Modal.Header>
                                    <Modal.Title>{currentUser?.lang && currentUser.lang === "el" ? "Αποστολή Αναφοράς στο MyData" : "Send To MyData Report"}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>{currentUser?.lang && currentUser.lang === "el" ? "Παρακάτω εμφανίζονται τα αποτελέσματα για την ακύρωση των επιλεγμένων Παραστατικών στο MyData:" : "Below are shown the results for the canceling of the selected Documents to MyData:"}<br/> {this.state.responseCancelToMyData}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="outline-primary" onClick={() => {
                                        this.setState((state) => {
                                            if (state.showResponseCancelToMyData) {
                                                return {
                                                    showResponseCancelToMyData: false,
                                                };
                                            }
                                        });
                                    }}>OK</Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    )}
                    <DeleteModal
                        showDelete={this.state.showDelete}
                        showDeleteModal={this.showDeleteModal}
                        toBeDeleted={this.state.toBeDeleted}
                        tableName={this.state.tableName}
                        updateFunction={this.props.handleAfterDelete}
                    />
                </div>
            </>
        );
    }
}
export default EditableTable;
